import {
  CButton,
  CCol,
  CInput,
  CLabel,
  CRow,
  CSpinner,
  CTextarea,
  CForm,
  CSelect,
  CTooltip,
  CCardBody,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Auth from "src/auth";
import { formatDate } from "src/shared/Format/dateFormat";
import {
  apiCall,
  apiCallResponse,
  apiCallSPGet,
  apiDownloadDocument,
  downloadUrl,
} from "src/_apiConfig/apiCall";
import { Paper } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import CommonList from "../common/CommonList";
import ConfirmationPopup from "../common/ConfirmationPopup";
import LotListViewGoDownRent from "./Lot/view/LotListViewGoDownRent";
import LotListViewGoDownRentFeeExtension from "./Lot/view/LotListViewGoDownRentFeeExtension";
import LotListViewLotLeftRequest from "./Lot/view/LotListViewLotLeftRequest";
import { AlertResponse } from "src/_constants/alert.type";
import ToastMessage from "src/_components/ToastMessage";
import ModalPaymentTransactionHistory from "./Lot/view/ModalPaymentTransactionHistory";
import LotListViewLotDocument from "./Lot/view/LotListViewLotDocument";
import LotListViewLotDetails from "./Lot/view/LotListViewLotDetails";
import CustomeModalPopup from "../common/CustomeModalPopup";
import LotListViewABS from "./Lot/view/LotListViewABS";
import LotListViewTenderDetails from "./Lot/view/LotListViewTenderDetails";
import LotListViewFooter from "./Lot/view/LotListViewFooter";
import LotListViewEMDAndSecurityDepositPayment from "./Lot/view/LotListViewEMDAndSecurityDepositPayment";
import LotListViewTransferButton from "./Lot/view/LotListViewTransferButton";
import LotListViewDownloadAgreementAndTransferLetter from "./Lot/view/LotListViewDownloadAgreementAndTransferLetter";
import LotListViewAgrement from "./Lot/view/LotListViewAgrement";
import TableButtonClick from "../common/Table/TableButtonClick";
import LotListViewBidderRefundInstallmentAdjustment from "./Lot/view/LotListViewBidderRefundInstallmentAdjustment";
import LotListViewAdHocPayment from "./Lot/view/LotListViewAdHocPayment";
import LotListViewTransferLotEMDPayment from "./Lot/view/LotListViewTransferLotEMDPayment";
import LotListViewTransferRefund from "./Lot/view/LotListViewTransferRefund";
import LotListViewTransferDetails from "./Lot/view/LotListViewTransferDetails";

const LotlistView = () => {
  const [toasts, setToasts] = useState(AlertResponse);
  let history = useHistory();

  let { lotId } = useParams();

  const Backdrop = styled("div")`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    -webkit-tap-highlight-color: transparent;
  `;
  const modalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };

  const stylTaxConsession = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    borderRadius: "4px",
    fontSize: "1rem",
    padding: "2rem",
  };

  // eslint-disable-next-line no-unused-vars
  const [loading, setloading] = useState(false);
  const [DistItems, setDistItems] = useState();
  const [viewListDetails, setviewListDetails] = useState();
  const [viewListDocument, setviewListDocument] = useState();
  const [viewTenderDetails, setviewTenderDetails] = useState();
  const [EmdPaid, setEmdPaid] = useState();
  //const [EmdRefundAfterLotTransfer, setEmdRefundAfterLotTransfer] = useState();
  const [FullPaymentLotDetails, setFullPaymentLotDetails] = useState();
  const [ABSPaymentDetails, setABSPaymentDetails] = useState();
  const [viewTransferDetails, setviewTransferDetails] = useState([]);
  const [viewPaymentDetails, setviewPaymentDetails] = useState([]);
  const [viewPaymentSlotsData, setviewPaymentSlotsData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [payTransferFee, setpayTransferFee] = useState(true);
  const [open, setOpen] = useState(false);

  //const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // eslint-disable-next-line no-unused-vars
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  // eslint-disable-next-line no-unused-vars

  const [isAnyPaidSlots, setisAnyPaidSlots] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [designation, setdesignation] = useState();
  const [paymentTransactionHistory, setpaymentTransactionHistory] = useState(
    []
  );

  const [IncomeTaxConsessionOpen, setIncomeTaxConsessionOpen] = useState();

  const [IncomeTaxConsessionLotNo, setIncomeTaxConsessionLotNo] = useState();
  const [IncomeTaxConsessionLotId, setIncomeTaxConsessionLotId] = useState();
  const [IsTaxConsessionRequired, setIsTaxConsessionRequired] = useState(true);
  const [LotPymentIdForIncomeTaxPay, setLotPymentIdForIncomeTaxPay] =
    useState();
  const [TaxConsessionPer, setTaxConsessionPer] = useState();
  const [RejectionReason, setRejectionReason] = useState();
  const [TaxConsessionDocument, setTaxConsessionDocument] = useState();
  const [IsTaxConsessionApprovedByHO, setIsTaxConsessionApprovedByHO] =
    useState();
  // eslint-disable-next-line no-unused-vars
  const [IsAdditionalSDAvailable, setIsAdditionalSDAvailable] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [IsAdditionalSDPaid, setIsAdditionalSDPaid] = useState(false);

  const [InstallmentAdjustLotNo, setInstallmentAdjustLotNo] = useState();
  const [InstallmentAdjustLotNoAmountMin, setInstallmentAdjustLotNoAmountMin] =
    useState();
  const [InstallmentAdjustLotPaymentId, setInstallmentAdjustLotPaymentId] =
    useState();
  const [InstallmentAdjustAmount, setInstallmentAdjustAmount] = useState();
  const [InstallmentAdjustComments, setInstallmentAdjustComments] = useState();
  const [InstallmentAdjustDocument, setInstallmentAdjustDocument] = useState();
  const [InstallmentAdjustmentOpen, setInstallmentAdjustmentOpen] = useState();

  const [GenerateParidhanAadeshOpen, setGenerateParidhanAadeshOpen] =
    useState(false);
  const [ParidhanAadeshPaymentId, setParidhanAadeshPaymentId] = useState();
  const [PADate, setPADate] = useState();
  const [TPNO, setTPNO] = useState();
  const [ForestRange, setForestRange] = useState();
  const [GodownName, setGodownName] = useState();
  const [PADistrictId, setPADistrictId] = useState();
  const [Address, setAddress] = useState();

  const [DueDays, setDueDays] = useState();
  const [ReceiverName1, setReceiverName1] = useState();
  const [ReceiverFName1, setReceiverFName1] = useState();
  const [ReceiverAddress1, setReceiverAddress1] = useState();
  const [ReceiverName2, setReceiverName2] = useState();
  const [ReceiverFName2, setReceiverFName2] = useState();
  const [ReceiverAddress2, setReceiverAddress2] = useState();

  const [paymentAmount, setPaymentAmount] = useState();
  // eslint-disable-next-line no-unused-vars
  const [finalAmount, setFinalAmount] = useState();
  const [CGSTAmount, setCGSTAmount] = useState();
  const [SGSTAmount, setSGSTAmount] = useState();

  const [EMDAmount, setEMDAmount] = useState();
  const [ADDAmount, setADDAmount] = useState();
  const [AdditionalSDAmount, setAdditionalSDAmount] = useState();
  const [SDAmt, setSDAmt] = useState();
  const [IsLastInstallmentForFullPayment, setIsLastInstallmentForFullPayment] =
    useState(false);
  const [IsSDPaidOnline, setIsSDPaidOnline] = useState(false);
  const [TotalLateFees, setTotalLateFees] = useState();
  const [IsLastInstallment, setIsLastInstallment] = useState(false);
  const [AdjustmentAmt, setAdjustmentAmt] = useState();
  const [IncomeTaxAmount, setIncomeTaxAmount] = useState();
  const [IGSTAmount, setIGSTAmount] = useState();
  const [accessBenefitSharingAmount, setAccessBenefitSharingAmount] =
    useState();
  const [rebateOnFullPayment, setRebateOnFullPayment] = useState();
  const [add5PerOnFinalAmount, setAdd5PerOnFinalAmount] = useState();
  const [IncomeTaxConsessionPercentage, setIncomeTaxConsessionPercentage] =
    useState();
  const [PaymentBreakoutOpen, setPaymentBreakoutOpen] = useState();
  const [IdForPaymentHistory, setIdForPaymentHistory] = useState();
  const [TypeForPaymentHistory, setTypeForPaymentHistory] = useState();
  const [LastInstallmentPriceBreakUp, setLastInstallmentPriceBreakUp] =
    useState([]);
    const [TotalSDAmountPB, setTotalSDAmountPB] = useState();

  const [GDRFEListData, setGDRFEListData] = useState([]); // List data manage //added By Deep Gandhi at 07-06-2024 For GoDown Rent Fee ExtensionRent

  const handleFinalInstallmentAdjustAmount = (
    lotNo,
    lotpaymentid,
    adjustmentAmt,
    document,
    comment,
    minAmtAllow
  ) => {
    setInstallmentAdjustLotNo(lotNo);
    setInstallmentAdjustLotPaymentId(lotpaymentid);
    setInstallmentAdjustAmount(adjustmentAmt);
    setInstallmentAdjustDocument(document);
    setInstallmentAdjustComments(comment);
    setInstallmentAdjustmentOpen(true);
    setInstallmentAdjustLotNoAmountMin(-Math.abs(minAmtAllow));
  };

  const handleGenerateParidhanAadesh = (lotpaymentid) => {
    setParidhanAadeshPaymentId(lotpaymentid);
    setGenerateParidhanAadeshOpen(true);
  };

  const handleOpenIncomeTaxConsessionPopup = (
    lotid,
    lotNo,
    lotPaymentId,
    isRequiedIncomeTaxConsession,
    incomeTaxConsessionPercentage,
    taxConsessionRejectionReason,
    incomeTaxConsessionDocument,
    isTaxConsessionApprovedByHO,
    totalSDAmt,
    IsFullPaymentInstallment,
    isSDAmountPaidOnline
  ) => {
    setIncomeTaxConsessionOpen(true);
    setIncomeTaxConsessionLotId(lotid);
    setIncomeTaxConsessionLotNo(lotNo);
    setLotPymentIdForIncomeTaxPay(lotPaymentId);
    setIsTaxConsessionRequired(true);
    setTaxConsessionPer(incomeTaxConsessionPercentage);
    setRejectionReason(taxConsessionRejectionReason);
    setTaxConsessionDocument(incomeTaxConsessionDocument);
    setIsTaxConsessionApprovedByHO(isTaxConsessionApprovedByHO);
    setSDAmt(totalSDAmt);
    setIsLastInstallmentForFullPayment(IsFullPaymentInstallment);
    setIsSDPaidOnline(isSDAmountPaidOnline);
    setTaxConsessionFileEvent(false);
    setTaxConsessionSelectedFile();
  };

  const handleOpenPaymentBreakOut = (
    paymentAmount,
    finalAmount,
    CGSTAmount,
    SGSTAmount,
    IGSTAmount,
    accessBenefitSharingAmount,
    add5PerOnFinalAmount,
    rebateOnFullPayment,
    incomeTaxAmount,
    incomeTaxConsessionPercentage,
    emdamt,
    addamt,
    additionalsdamt,
    totallatefees,
    lastinstallment,
    adjustmentAmount,
    lastInstallmentPriceBreakUp,
    TotalSDAmountPB
  ) => {
    setPaymentBreakoutOpen(true);
    setPaymentAmount(paymentAmount);
    setFinalAmount(finalAmount);
    setCGSTAmount(CGSTAmount);
    setSGSTAmount(SGSTAmount);
    setIGSTAmount(IGSTAmount);
    setAdd5PerOnFinalAmount(add5PerOnFinalAmount);
    setAccessBenefitSharingAmount(accessBenefitSharingAmount);
    setRebateOnFullPayment(rebateOnFullPayment);
    setIncomeTaxAmount(incomeTaxAmount);
    setIncomeTaxConsessionPercentage(incomeTaxConsessionPercentage);
    setEMDAmount(emdamt);
    setADDAmount(addamt);
    setAdditionalSDAmount(additionalsdamt);
    setTotalLateFees(totallatefees);
    setIsLastInstallment(lastinstallment);
    setAdjustmentAmt(adjustmentAmount);
    setLastInstallmentPriceBreakUp(lastInstallmentPriceBreakUp);
    setTotalSDAmountPB(TotalSDAmountPB);
  };

  const HandlerTaxConsessionSubmit = async (e) => {
    e.preventDefault();
    if (IsTaxConsessionRequired === true && TaxConsessionPer === "") {
      alert("Please insert tax consession percentage");
      //  return false;
    } else if (isNaN(TaxConsessionPer)) {
      alert("Enter Numeric value for Tax Consession Percentage");
    } else if (Number(TaxConsessionPer) < 0 || Number(TaxConsessionPer) > 2) {
      alert("Tax Consession Percentage should be between 0 to 2");
    } else if (
      Number(TaxConsessionPer) < 2 &&
      IsTaxConsessionRequired === true &&
      (TaxConsessionSelectedFile === null ||
        TaxConsessionSelectedFile === undefined)
    ) {
      alert("Please upload document in case you required tax concession");
    } else if (
      Number(TaxConsessionPer) < 2 &&
      TaxConsessionSelectedFile != null &&
      TaxConsessionSelectedFile !== undefined &&
      TaxConsessionFileEvent !== null &&
      TaxConsessionFileEvent.target.files[0].type !== "application/pdf"
    ) {
      // let fileEvent = TaxConsessionFileEvent;
      // if (fileEvent.target.files[0].type !== "application/pdf") {
      alert("Please Upload Only pdf file!");
      // }
    } else if (
      Number(TaxConsessionPer) === 2 &&
      TaxConsessionSelectedFile != null &&
      TaxConsessionSelectedFile !== undefined &&
      TaxConsessionFileEvent !== null &&
      TaxConsessionFileEvent.target.files[0].type !== "application/pdf"
    ) {
      // let fileEvent = TaxConsessionFileEvent;
      // if (fileEvent.target.files[0].type !== "application/pdf") {
      alert("Please Upload Only pdf file!");

      // }
    } else {
      let file = TaxConsessionSelectedFile;
      let filename = "";
      if (file !== null && file !== undefined) {
        filename = file.name;
      }

      const header = new Headers();
      header.append("Content-Type", "application/json");

      const response = await apiCall(
        "LotDetails/UpdateIncometaxConsessionDetails",
        "POST",
        header,
        JSON.stringify({
          lotId: decrypted,
          IsRequiedIncomeTaxConsession: !!IsTaxConsessionRequired,
          taxConsessionPer: TaxConsessionPer,
          incomeTaxConsessionDocument: filename,
          lotPaymentId: LotPymentIdForIncomeTaxPay,
          AdditionalSDAmount: SDAmt,
          IsFullPayment: IsLastInstallmentForFullPayment,
          IsSDAmountPaidOnline: IsSDPaidOnline,
        })
      );

      await response.json();
debugger;
      if (response.status === 200) {
        console.log(response);
        debugger;
        alert("Submit Successfully");
        let etaxfileevent = TaxConsessionFileEvent;

        if (etaxfileevent !== false) {
          SaveTaxConsessionDoc(LotPymentIdForIncomeTaxPay);
        } else {
          window.location.reload();
        }
      }
    }
  };
  const HandlerInstallmentAdjustmentSubmit = async (e) => {
    e.preventDefault();

    let file = InstallmentAdjustmentFile;
    let filename = "";
    if (file !== null && file !== undefined) {
      filename = file.name;
    }
    let fileEvent = InstallmentAdjustmentFileEvent;
    if (
      fileEvent != false &&
      fileEvent.target.files[0].type !== "application/pdf"
    ) {
      alert("Please Upload Only pdf file!");
    } else {
      const header = new Headers();
      header.append("Content-Type", "application/json");

      const response = await apiCall(
        "LotDetails/UpdateInstallmentAdjustmentAmount",
        "POST",
        header,
        JSON.stringify({
          lotPaymentId: InstallmentAdjustLotPaymentId,
          AdjustmentAmount: Number(InstallmentAdjustAmount),
          Comments: InstallmentAdjustComments,
          DocumentName: filename,
          InstallmentAdjustmentByDFOId: authenticated.userId,
        })
      );

      await response.json();

      if (response.status === 200) {
        alert("Installment Details Updated Successfully");

        let etaxfileevent = InstallmentAdjustmentFileEvent;
        if (etaxfileevent === false) {
        }
        if (etaxfileevent !== false) {
          SaveInstallmentAdjustmentDoc(InstallmentAdjustLotPaymentId);
        } else {
          window.location.reload();
        }
      }
    }
  };
  const HandlerGenerateParidhanAadeshSubmit = async (e) => {
    e.preventDefault();
    const header = new Headers();
    header.append("Content-Type", "application/json");

    const response = await apiCall(
      "LotDetails/UpdateParidhanAadeshDetails",
      "POST",
      header,
      JSON.stringify({
        PADate: PADate,
        ForestRange: ForestRange,
        GodownName: GodownName,
        PADistrictId: PADistrictId,
        Address: Address,
        TPNO: TPNO,
        DueDays: DueDays,
        ReceiverName1: ReceiverName1,
        ReceiverFName1: ReceiverFName1,
        ReceiverAddress1: ReceiverAddress1,
        ReceiverName2: ReceiverName2,
        ReceiverFName2: ReceiverFName2,
        ReceiverAddress2: ReceiverAddress2,
        LotPaymentId: ParidhanAadeshPaymentId,
      })
    );

    await response.json();

    if (response.status === 200) {
      alert("Godown details for Paridhan Aadesh Updated Successfully");

      // let etaxfileevent = InstallmentAdjustmentFileEvent;
      // if (etaxfileevent === false) {
      // }
      // if (etaxfileevent !== false) {
      //   SaveInstallmentAdjustmentDoc(InstallmentAdjustLotPaymentId);
      // } else {
      window.location.reload();
      // }
    }
  };

  const HandlerBGRefundSubmit = async (e) => {
    e.preventDefault();
    const header = new Headers();
    header.append("Content-Type", "application/json");

    const response = await apiCall(
      "LotDetails/SubmitBGRefundDetails",
      "POST",
      header,
      JSON.stringify({
        LotId: BGRefundLotId,
        Comments: BGRefundComment,
        BGRefundDate: BGRefundDate,
        BGRefundedByDFOId: authenticated.userId,
      })
    );

    await response.json();

    if (response.status === 200) {
      alert("Submit Successfully");
      window.location.reload();
    }
  };
  const Handler5PerRefunfRequestOnFullPayment = async (e) => {
    e.preventDefault();

    const header = new Headers();
    header.append("Content-Type", "application/json");

    const response = await apiCall(
      "LotDetails/Generate5PerRefundRequestOnFullPayment",
      "POST",
      header,
      JSON.stringify({
        LotId: decrypted,
      })
    );

    await response.json();

    if (response.status === 200) {
      alert("Refund Request Generated Successfully");
      window.location.reload();
    }
  };

  const SaveTaxConsessionDoc = async (LotPymentIdForIncomeTaxPay) => {
    let fileEvent = TaxConsessionFileEvent;
    let file = TaxConsessionSelectedFile;
    if (fileEvent !== false) {
      if (authenticated) {
        if (fileEvent.target.files[0].type === "application/pdf") {
          // setSelectedFile(e.target.files[0]);
          //const files = fileEvent.target.files[0];
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");

          formData.append("file", file);
          const response = await apiCall(
            `LotDetails/UploadIncomeTaxConsessionCertificate/${LotPymentIdForIncomeTaxPay}`,
            "POST",
            header,
            formData
          );

          await response.text();

          if (response.status === 200) {
            //alert("Document Uploaded Successfully!");
            setTaxConsessionSelectedFile();
            setTaxConsessionFileEvent(false);
            window.location.reload();
          } else {
            alert("Error to upload file!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    }
  };

  const SaveInstallmentAdjustmentDoc = async (LotPymentIdForAdjustment) => {
    let fileEvent = InstallmentAdjustmentFileEvent;
    let file = InstallmentAdjustmentFile;
    if (fileEvent !== false) {
      if (authenticated) {
        if (fileEvent.target.files[0].type === "application/pdf") {
          //const files = fileEvent.target.files[0];
          const formData = new FormData();
          const header = new Headers();
          header.append("Accept", "application/json");
          formData.append("file", file);
          const response = await apiCall(
            `LotDetails/UploadAdjustmentCertificate?lotid=${decrypted}&pid=${InstallmentAdjustLotPaymentId}`,
            "POST",
            header,
            formData
          );
          await response.text();

          if (response.status === 200) {
            //alert("Document Uploaded Successfully!");
            setInstallmentAdjustmentFile();
            setInstallmentAdjustmentFileEvent(false);
            window.location.reload();
          } else {
            alert("Error in file upload!");
          }
        } else {
          alert("Please Upload Only pdf file!");
        }
      }
    }
  };

  const handleDownloadTaxConsessionDocument = async (lotid, lotPaymentId) => {
    const header = new Headers();
    const url = `LotDetails/DownloadTaxConsessionDocument?lotid=${Number(
      lotid
    )}&lotpaymentid=${Number(lotPaymentId)}`;
    const fileName = lotid + "_" + lotPaymentId + ".pdf";
    await apiDownloadDocument(fileName, url, "GET", header, null).then(
      (res) => {
        if (!res.success) alert(res.message);
      }
    );
  };

  const handleDownloadParidhanAadesh = async (lotPaymentId) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadParidhanAadeshNew?lotid=${Number(
        decrypted
      )}&lotpaymentid=${Number(lotPaymentId)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    jsonobj.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = decrypted + "_" + lotPaymentId + ".pdf";
      alink.click();
    });
  };

  const handleDownloadInstallmentAdjustmentDocument = async (lotPaymentId) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/DownloadFinalAmountAdjustmentDocument?lotid=${Number(
        decrypted
      )}&lotpaymentid=${Number(lotPaymentId)}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response;
    jsonobj.blob().then((blob) => {
      const fileURL = window.URL.createObjectURL(blob);
      // Setting various property values
      let alink = document.createElement("a");
      alink.href = fileURL;
      alink.download = decrypted + "_" + lotPaymentId + ".pdf";
      alink.click();
    });
  };

  const handleIncomeTaxConsessionClose = () =>
    setIncomeTaxConsessionOpen(false);

  const handleInstallmentAdjustmentClose = () =>
    setInstallmentAdjustmentOpen(false);
  const handleParidhanAadeshClose = () => setGenerateParidhanAadeshOpen(false);
  const handleBGRefundClose = () => setBGRefundPopUpOpen(false);
  const handlePaymentBreakoutClose = () => setPaymentBreakoutOpen(false);

  const [showList, setshowList] = useState();
  const [terminationMsg, setterminationMsg] = useState();

  const { authenticated } = Auth();
  const decrypted = window.atob(lotId);
  // eslint-disable-next-line no-unused-vars
  // const [selectedFile, setSelectedFile] = useState();
  // const [fileEvent, setFileEvent] = useState(false);
  //const [documentName, setdocumentName] = useState("");

  const [TaxConsessionSelectedFile, setTaxConsessionSelectedFile] = useState();
  const [TaxConsessionFileEvent, setTaxConsessionFileEvent] = useState(false);

  const [InstallmentAdjustmentFile, setInstallmentAdjustmentFile] = useState();
  const [InstallmentAdjustmentFileEvent, setInstallmentAdjustmentFileEvent] =
    useState(false);

  // eslint-disable-next-line no-unused-vars
  const [IsEMDRefunded, setIsEMDRefunded] = useState(false);
  const [IsSDRefunded, setIsSDRefunded] = useState(false);
  const [IsSDRefunded5Per, setIsSDRefunded5Per] = useState(false);
  const [refundStatusList, setrefundStatusList] = useState();
  const [refundopen, setrefundopen] = useState(false);
  /* File upload end */
  const [showpaymentHistory, setshowpaymentHistory] = useState(false);
  const [BGRefundLotNo, setBGRefundLotNo] = useState();
  const [BGRefundLotId, setBGRefundLotId] = useState();
  const [BGRefundAmount, setBGRefundAmount] = useState();
  const [BGRefundComment, setBGRefundComment] = useState();
  const [BGRefundDate, setBGRefundDate] = useState();
  const [BGRefundPopUpOpen, setBGRefundPopUpOpen] = useState();
  const [disableInstallmentAdjustment, setDisableInstallmentAdjustment] =
    useState(true);
  const [disable5PerRefundButton, setDisable5PerRefundButton] = useState(true);
  const [disableEMDRefundButton, setDisableEMDRefundButton] = useState(true);
  const [disableSDRefundButton, setDisableSDRefundButton] = useState(true);
  const [disable25PerSDRefund, setDisable25PerSDRefund] = useState(true);
  const [showEMDRefundButton, setShowEMDRefundButton] = useState(true);

  //Confirmation popup------------------------------------
  const [CPopUpId, setCPopUpId] = useState();
  const [CPopUpIndex, setCPopUpIndex] = useState();
  const [CPopUpDisplayConfirmationModal, setCPopUpDisplayConfirmationModal] =
    useState(false);
  const [CPopUpBodyText, setCPopUpBodyText] = useState();
  const [CPopUpAmount, setCPopUpAmount] = useState();
  const [CPopUpLotPaymentId, setCPopUpLotPaymentId] = useState();
  const [CPopUpRebat, setCPopUpRebat] = useState();
  const [CPopUpAdditionalSD, setCPopUpAdditionalSD] = useState();
  const [CPopUpTotalLateFees, setCPopUpTotalLateFees] = useState();
  const [CPopUpCGSTAmt, setCPopUpCGSTAmt] = useState();
  const [CPopUpSGSTAmt, setCPopUpSGSTAmt] = useState();
  const [CPopUpIGSTAmt, setCPopUpIGSTAmt] = useState();
  const [CPopUpEMDPer, setCPopUpEMDPer] = useState();
  const [CPopUpIsPayWOTDS, setCPopUpIsPayWOTDS] = useState();
  const [CPopUpFilePath, setCPopUpFilePath] = useState();
  const [CPopUpOtherId, setCPopUpOtherId] = useState();
  ///refund popup
  const [CPopUpLotId, setCPopUpLotId] = useState();
  const [CPopUpLotNo, setCPopUpLotNo] = useState();
  const [CPopUpTenderId, setCPopUpTenderId] = useState();
  const [CPopUpUserId, setCPopUpUserId] = useState();
  const [CPopUpRefundType, setCPopUpRefundType] = useState();
  const [CPopUpIsEMDRefundFileCancelled, setCPopUpIsEMDRefundFileCancelled] =
    useState();

  const handleConfirmationPopUpModalClose = () =>
    setCPopUpDisplayConfirmationModal(false);
  //-------------------------------------------------------

  const ShowRefundHistory = async (tenderid, lotno, type) => {
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/GetRefundStatus?tenderid=${tenderid}&lotno=${lotno}&refundtype=${Number(
        type
      )}`,
      "GET",
      header,
      null
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      console.log(jsonobj);
      setrefundStatusList(jsonobj);
    }

    setrefundopen(true);
  };

  // const handleRefundPopupOpen = (lotno) => {
  //   setrefundopen(true);
  // };
  const handleOpenBGRefundPopup = (lotid, lotno, amount) => {
    setBGRefundPopUpOpen(true);
    setBGRefundLotId(lotid);
    setBGRefundLotNo(lotno);
    setBGRefundAmount(amount);
  };
  const handleRefundPopupClose = () => setrefundopen(false);

  const BGPaymentStatusViewHanlder = async (filePath) => {
    const header = new Headers();
    const response = await apiCall(
      `Report/DownloadBGReceipt?filepath=${filePath}`,
      "GET",
      header,
      null
    );
    const jsonobj = await response;

    if (jsonobj.status === 200) {
      jsonobj.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = filePath;
        alink.click();
      });
    } else {
      alert("Receipt not available");
    }
  };
  const BGPaymentHandler = async (lotid, type) => {
    history.push(`/OfflinePaymentWithType/${lotId}/${type}`, {
      from: window.location.href,
    });
  };
  const fieldsRefunds = [
    {
      key: "srno",
      label: "SRNO",
    },
    {
      key: "date",
      label: "Date",
    },
    {
      key: "beneficiary_bank_name",
      label: "Bank Name",
    },
    {
      key: "beneficiary_account_number",
      label: "Account Number",
    },
    {
      key: "beneficiary_bank_ifsc",
      label: "IFSC Code",
    },
    {
      key: "refund_percentage",
      label: "Lot %",
    },
    {
      key: "amount",
      label: "Amount",
    },
    {
      key: "status",
      label: "Status",
    },
    {
      key: "refundType",
      label: "Refund Type",
    },
    {
      key: "rejectionreason",
      label: "Comment/Reason",
    },
    {
      key: "download_Refund_lot_receipt",
      label: "Download Receipt",
    },
  ];

  const getDistrictList = async () => {
    setloading(true);
    const header = new Headers();
    const distResponse = await apiCall(`District_Master`, "GET", header, null);
    const distJsonobj = await distResponse.json();
    if (distResponse.status === 200) {
      setDistItems(distJsonobj);
    }
    setloading(false);
  };

  const InitiateTransferEMDRefund = async (
    lotid,
    userid,
    isEMDRefundFileCancelled
  ) => {
    setloading(true);
    setShowEMDRefundButton(false);
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/InitiateTransferEMDRefund?lotid=${lotid}&userid=${userid}&isRFC=${isEMDRefundFileCancelled}`,
      "GET",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      setloading(false);
      window.location.reload();
    }
  };

  const InitiateRefund = async (lotid, type, lotno, tenderid) => {
    setloading(true);
    if (type === 7) {
      setDisableInstallmentAdjustment(true);
    } else if (type === 4) {
      setDisable5PerRefundButton(true);
    } else if (type === 2) {
      setDisableEMDRefundButton(true);
    } else if (type === 3) {
      setDisableSDRefundButton(true);
    } else if (type === 6) {
      setDisable25PerSDRefund(true);
    }
    const header = new Headers();
    const response = await apiCall(
      `LotDetails/CreateSecurityDepositeRefund?lotid=${lotid}&type=${Number(
        type
      )}&lotno=${lotno}&tenderid=${tenderid}&userid=${authenticated.userId}`,
      "GET",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      setloading(false);
      window.location.reload();
    }
  };

  // function makeid(length) {
  //   var result = "";
  //   var characters =
  //     "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  //   var charactersLength = characters.length;
  //   for (var i = 0; i < length; i++) {
  //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  //   }
  //   return result;
  // }

  const FullPaymentHanlder = async (
    amount,
    lotpaymentid,
    AdditionalSDAmount
  ) => {
    // e.preventDefault();

    // const header = new Headers();
    // header.append("Content-Type", "application/json");

    // const response = await apiCall(
    //   "LotDetails/UpdateAdditionalSDAmountForFullPayment",
    //   "POST",
    //   header,
    //   JSON.stringify({
    //     AdditionalSDAmountForFinalPayment : Number(AdditionalSDAmount),
    //     LotPaymentId: Number(lotpaymentid),
    //     LateFees: Number(lateFees)

    //  })
    // );

    // const jsonobj = await response.json();

    // if (response.status === 200) {

    // }
    // else
    // {getLotDetails
    //   alert('Error Occured on Additional Amount Update for Full Payment');

    // }

    history.push(`/submitpayment/${decrypted}/${amount}/${lotpaymentid}`, {
      from: window.location.href,
    });
  };

  //const ViewBGHandler = () => {};

  const PaymentStatusViewHanlder = async (tranid) => {
    history.push(`/receipt/${tranid}`, {
      from: window.location.href,
    });
  };

  const CancelChallanHanlder = async (paymentId) => {
    if (authenticated) {
      const header = new Headers();
      const response = await apiCall(
        `LotDetails/cancelChallan?paymentId=${paymentId}`,
        "GET",
        header,
        null
      );
      const jsonobj = await response.json();
      if (response.status === 200 && jsonobj === true) {
        window.location.reload();
        setshowList(false);
        getLotDetails(true);
      }
    }
  };

  const RefundConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext,
    lotid,
    lotno,
    tenderid,
    userid,
    refundtype,
    isEMDRefundFileCancelled
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
    setCPopUpLotId(lotid);
    setCPopUpLotNo(lotno);
    setCPopUpTenderId(tenderid);
    setCPopUpUserId(userid);
    setCPopUpRefundType(refundtype);
    setCPopUpIsEMDRefundFileCancelled(isEMDRefundFileCancelled);
  };

  const ConfirmationPopupHandler = async (
    popupid,
    popupindex,
    popupbodytext,
    amount,
    lotpaymentid,
    rebat,
    additionalSD,
    totalLateFees,
    cgstamt,
    sgstamt,
    igstamt,
    percentage,
    ispaywithouttds,
    filepath,
    otherId = 0
  ) => {
    setCPopUpId(popupid);
    setCPopUpIndex(popupindex);
    setCPopUpDisplayConfirmationModal(true);
    setCPopUpBodyText(popupbodytext);
    setCPopUpAmount(amount);
    setCPopUpLotPaymentId(lotpaymentid);
    setCPopUpRebat(rebat);
    setCPopUpAdditionalSD(additionalSD);
    setCPopUpTotalLateFees(totalLateFees);
    setCPopUpCGSTAmt(cgstamt);
    setCPopUpSGSTAmt(sgstamt);
    setCPopUpIGSTAmt(igstamt);
    setCPopUpEMDPer(percentage);
    setCPopUpIsPayWOTDS(ispaywithouttds);
    setCPopUpFilePath(filepath);
    setCPopUpOtherId(otherId);
    //alert("inside popup handler");
  };

  //const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const SubmitConfirmationPopUpResponse = async () => {
    handleConfirmationPopUpModalClose();
    if (CPopUpId === 1) {
      PaymentHanlder(CPopUpAmount, 0, 0, 0, 0, 0, 0, 0);
    } else if (CPopUpId === 2) {
      PaymentHanlder(
        CPopUpAmount,
        CPopUpLotPaymentId,
        CPopUpRebat,
        CPopUpAdditionalSD,
        CPopUpTotalLateFees,
        CPopUpCGSTAmt,
        CPopUpSGSTAmt,
        CPopUpIGSTAmt
      );
    } else if (CPopUpId === 3) {
      FullPaymentHanlder(CPopUpAmount, CPopUpLotPaymentId, CPopUpAdditionalSD);
    } else if (CPopUpId === 4) {
      TransferLotEMDPayment(CPopUpEMDPer);
    } else if (CPopUpId === 5) {
      GoDowonRentPayment(
        CPopUpLotPaymentId,
        CPopUpAmount,
        CPopUpTotalLateFees,
        CPopUpIsPayWOTDS,
        CPopUpFilePath
      );
    } else if (CPopUpId === 6) {
      InitiateTransferEMDRefund(
        CPopUpLotId,
        CPopUpUserId,
        CPopUpIsEMDRefundFileCancelled
      );
    } else if (CPopUpId === 7) {
      InitiateRefund(
        CPopUpLotId,
        CPopUpRefundType,
        CPopUpLotNo,
        CPopUpTenderId
      );
    } else if (CPopUpId === 8) {
      GoDowonRentFeeExtensionPayment(
        CPopUpLotPaymentId,
        CPopUpOtherId,
        CPopUpAmount,
        CPopUpTotalLateFees,
        CPopUpIsPayWOTDS,
        CPopUpFilePath
      );
    } else if (CPopUpId === 9) {
      AdHocPaymentPayment(
        CPopUpLotPaymentId,
        CPopUpOtherId,
        CPopUpAmount,
        CPopUpTotalLateFees,
        CPopUpIsPayWOTDS,
        CPopUpFilePath
      );
    }
  };

  const PaymentHanlder = async (
    amount,
    lotpaymentid,
    rebat,
    additionalSD,
    totalLateFees,
    cgstamt,
    sgstamt,
    igstamt
  ) => {
    if (totalLateFees > 0) {
      const header = new Headers();
      header.append("Content-Type", "application/json");
      const response = await apiCall(
        "LotDetails/UpdateFinalPriceOnRebet",
        "POST",
        header,
        JSON.stringify({
          AdditionalSDAmountForFinalPayment: Number(additionalSD),
          LotPaymentId: Number(lotpaymentid),
          LateFees: Number(totalLateFees),
          Rebate: Number(rebat),
          CGSTAmount: Number(cgstamt),
          SGSTAmount: Number(sgstamt),
          IGSTAmount: Number(igstamt),
        })
      );
      await response.json();

      if (response.status === 200) {
        history.push(`/submitpayment/${decrypted}/${amount}/${lotpaymentid}`, {
          from: window.location.href,
        });
      } else {
        alert("Error in Final Price Update");
      }
    } else {
      history.push(`/submitpayment/${decrypted}/${amount}/${lotpaymentid}`, {
        from: window.location.href,
      });
    }
  };

  const TransferLotEMDPayment = async (paymenttype) => {
    if (paymenttype === 15) {
      history.push(`/SelectyourpaymentForTransferlotEMD/${lotId}`, {
        from: window.location.href,
      });
    } else {
      history.push(
        `/submitlottransferemdpayment/${lotId}/${window.btoa(paymenttype)}`,
        {
          from: window.location.href,
        }
      );
    }
  };

  const GoDowonRentPayment = async (
    id,
    amount,
    latefees,
    ispaywithouttds,
    tdsfilepath
  ) => {
    history.push(
      `/submitgodownrentpayment/${window.btoa(id)}/${window.btoa(
        amount
      )}/${window.btoa(latefees)}/${window.btoa(ispaywithouttds)}`,
      {
        from: window.location.href,
      }
    );
  };
  const GoDowonRentFeeExtensionPayment = async (
    id,
    grefid,
    amount,
    latefees,
    ispaywithouttds,
    tdsfilepath
  ) => {
    history.push(
      `/submitgodownrentfeeextensionpayment/${window.btoa(id)}/${window.btoa(
        grefid
      )}/ ${window.btoa(amount)}/${window.btoa(latefees)}/${window.btoa(
        ispaywithouttds
      )}`,
      {
        from: window.location.href,
      }
    );
  };

  const AdHocPaymentPayment = async (id, ahpid, amount, latefees) => {
    history.push(
      `/submitadhocpayment/${window.btoa(id)}/${window.btoa(
        ahpid
      )}/${window.btoa(amount)}/${window.btoa(latefees)}`,
      {
        from: window.location.href,
      }
    );
  };

  const ViewBankTransaction = async (lotId, paymentType) => {
    setIdForPaymentHistory(lotId);
    setTypeForPaymentHistory(paymentType);
    setloading(true);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "PaymentHistory/GetPaymentHistory",
      "POST",
      header,
      JSON.stringify({
        LotId: lotId,
        PaymentType: paymentType,
      })
    );

    const jsonobj = await response.json();
    if (response.status === 200) {
      setpaymentTransactionHistory(jsonobj);
    } else {
      setpaymentTransactionHistory([]);
    }
    setloading(false);
    setshowpaymentHistory(true);
  };

  // const CheckTransactionStatus = async (lotId, paymentType) => {
  //   setloading(true);
  //   const header = new Headers();
  //   header.append("Content-Type", "application/json");
  //   const response = await apiCall(
  //     "PaymentHistory/CheckStatus",
  //     "POST",
  //     header,
  //     JSON.stringify({
  //       LotId: lotId,
  //       PaymentType: paymentType,
  //     })
  //   );
  //   const jsonobj = await response.json();
  //   if (response.status === 200) {
  //     setpaymentTransactionHistory(jsonobj);
  //   } else {
  //     setpaymentTransactionHistory([]);
  //   }
  //   setloading(false);
  //   setshowpaymentHistory(true);
  // };

  const generateAadeshLetter = async () => {
    let letterurl = `${downloadUrl}/ParidhanAadeshLetters/15078_paridhanaadesh.pdf`;
    window.open(letterurl, "_blank");

    // const header = new Headers();
    // const response = await apiCall(
    //   `LotDetails/GenerateParidhanAadeshLetter?lotId=${decrypted}`,
    //   "GET",
    //   header,
    //   null
    // );
    // const jsonobj = await response.json();
    // if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
    //   let letterurl = `${downloadUrl}/ParidhanAadeshLetters/${decrypted}/${decrypted}.pdf`;
    //   window.open(letterurl, "_blank");
    // }
  };

  const updateSanction = async (isSanctionAccepted) => {
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/updateIsSanctionAccepted?lotId=${decrypted}&isSanctionAccepted=${isSanctionAccepted}`,
      "PUT",
      header,
      null
    );
    const jsonobj = await response.json();
    if (response.status === 200 && jsonobj !== -1 && jsonobj !== -2) {
      window.location.reload();
      setshowList(false);
      getLotDetails(true);
    }
  };

  const terminateLot = async (e) => {
    e.preventDefault();
    handleClose();
    setshowList(false);
    const header = new Headers();
    // header.append("", "");

    const response = await apiCall(
      `LotDetails/TerminateLot?lotId=${decrypted}&msg=${terminationMsg}`,
      "PUT",
      header,
      null
    );
    await response.json();
    if (response.status === 200) {
      window.location.reload();
      setshowList(false);
      setOpen(false);
      getLotDetails(true);
    }
  };

  const getLotDocument = async (e) => {
    if (authenticated) {
      const header = new Headers();
      await apiCallResponse(
        `LotDetails/GetAllDocumentByLotId?lotId=${e}`,
        "GET",
        header,
        null
      ).then((res) => {
        if (res.success) {
          setviewListDocument(res.data);
        }
      });
    }
  };

  const getLotDetails = async (firstRequest) => {
    if (authenticated) {
      const header = new Headers();
      // header.append("", "");

      const response = await apiCall(
        //`LotDetails/GetLotDetailsById?$filter=lotId eq ${decrypted}`,
        `LotDetails/GetLotDetailsById?lotid=${decrypted}`,
        "GET",
        header,
        null
      );

      const jsonobj = await response.json();

      if (response.status === 200) {
        setviewListDetails(jsonobj[0]);
   
        if (jsonobj[0].isEMDRefundGenerated) setIsEMDRefunded(true);
        if (jsonobj[0].isSDRefundGenerated) setIsSDRefunded(true);
        if (jsonobj[0].is5PerRefundApprovedByDFO) setIsSDRefunded5Per(true);
        setDisableInstallmentAdjustment(
          jsonobj[0].disableInstallmentAdjustment
        );

        setDisable5PerRefundButton(jsonobj[0].disable5PerRefundButton);
        setDisableEMDRefundButton(jsonobj[0].disableEMDRefundButton);
        setDisable25PerSDRefund(jsonobj[0].disable25PerSDRefund);
        setDisableSDRefundButton(jsonobj[0].disableSDRefundButton);
        setShowEMDRefundButton(jsonobj[0].showEMDRefundButton);

        getLotDocument(jsonobj[0].lotId);

        getGoDownRentFeeExtensionList(jsonobj[0].lotId);

        const responseData = await apiCall(
          `Tender/GetLotDetails?$filter=tenderId eq ${jsonobj[0].tenderId}`,
          "GET",
          header,
          null
        );

        const jsonobjData = await responseData.json();

        if (responseData.status === 200) {
          setviewTenderDetails(jsonobjData[0]);

          // Check EMD paid
          await getCheckEMDPaid(decrypted, header);

          //NIKITA: Get ABSPaymentDetails
          await getABSPaymentLot(decrypted, header);

          //Get lotPayment for slot id -2
          await getFullPayment(decrypted, header);
          //debugger;
          //Get lotPayment
          await getLotPayment(decrypted, header);

          //Get LotTransfer
          await getLotTransfer(decrypted, header);

          setshowList(true);
        }
      }
    } else {
      setshowList(false);
    }
  };

  // Check EMD paid
  const getCheckEMDPaid = async (decrypted, header) => {
    const responseCheckEMDPaid = await apiCall(
      `LotDetails/CheckEMDPaid?LotId=${decrypted}`,
      "GET",
      header,
      null
    );

    const jsonobjCheckEMDPaid = await responseCheckEMDPaid.json();
    setEmdPaid(jsonobjCheckEMDPaid);
  };
  const getABSPaymentLot = async (decrypted, header) => {
    //NIKITA: Get ABSPaymentDetails
    const responseABSPaymentLot = await apiCall(
      `LotDetails/GetABSPaymentDetails?LotId=${decrypted}`,
      "GET",
      header,
      null
    );
    const jsonABSPaymentLot = await responseABSPaymentLot.json();
    setABSPaymentDetails(jsonABSPaymentLot);
  };
  //Get lotPayment
  const getFullPayment = async (decrypted, header) => {
    const responseFullPaymentLot = await apiCall(
      `LotDetails/GetFullPaymentLotDetails?LotId=${decrypted}`,
      "GET",
      header,
      null
    );
    const jsonFullPaymentLot = await responseFullPaymentLot.json();
    setFullPaymentLotDetails(jsonFullPaymentLot);
  };
  //Get lotPayment
  const getLotPayment = async (decrypted, header) => {
    const responseSlotsData = await apiCall(
      `LotDetails/getlotpaymentslots?LotId=${decrypted}`,
      "GET",
      header,
      null
    );

    const jsonobjSlotsData = await responseSlotsData.json();

    if (responseSlotsData.status === 200 && jsonobjSlotsData.length > 0) {
      debugger;
      setviewPaymentSlotsData(jsonobjSlotsData);

      if (jsonobjSlotsData[0].tenderPaymentSlotsId === -3) {
        setIsAdditionalSDAvailable(true);
      } else {
        setIsAdditionalSDAvailable(false);
      }
      if (
        jsonobjSlotsData[0].tenderPaymentSlotsId === -3 &&
        jsonobjSlotsData[0].tenderPaymentSlotsId.paymentId > 0 &&
        jsonobjSlotsData[0].tenderPaymentSlotsId.PaidStatus.toLowerCase() ===
          "success"
      ) {
        setIsAdditionalSDPaid(true);
      } else {
        setIsAdditionalSDPaid(false);
      }

      var paidRecords = jsonobjSlotsData.filter(
        (l) =>
          l.paymentId != null && l.paymentId > 0 && l.paidStatus === "Success"
      ).length;
      setisAnyPaidSlots(paidRecords);
    }
  };

  //Get LotTransfer
  const getLotTransfer = async (decrypted, header) => {
    const responseTransferData = await apiCall(
      `LotTransfer?$filter=lotId eq ${decrypted}`,
      "GET",
      header,
      null
    );
    const jsonobjTransferData = await responseTransferData.json();

    if (responseTransferData.status === 200 && jsonobjTransferData.length > 0) {
      setviewTransferDetails(jsonobjTransferData);
      jsonobjTransferData.map(async (data) => {
        const responsePaymentData = await apiCall(
          `OfflinePayment/Get?$filter=objectId eq ${data.lotTransferId}`,
          "GET",
          header,
          null
        );
        const jsonobjPaymentData = await responsePaymentData.json();

        if (
          responsePaymentData.status === 200 &&
          jsonobjPaymentData.length > 0
        ) {
          //jsonobjPaymentData.map((paymentData) => {
          jsonobjPaymentData.forEach((paymentData) => {
            let arr = viewPaymentDetails;
            let condition = arr.find((data) => data.id === paymentData.id);

            if (condition === undefined && jsonobjPaymentData.length > 0) {
              arr.push(paymentData);
              setviewPaymentDetails(arr);

              // if (paymentData.status === 2) {
              //   setpayTransferFee(true);
              // } else if (
              //   paymentData.status === 0 ||
              //   paymentData.status === 1
              // ) {
              //   setpayTransferFee(false);
              // } else {
              //   setpayTransferFee(true);
              // }
            }
          });
        }
      });
    }
  };

  useEffect(() => {
    if (lotId !== "") {
      getLotDetails(true);
      getDistrictList(true);

      if (authenticated.role === "CFO" && authenticated.isViewOnly) {
        setdisabledApproveRej(true);
      } else {
        setdisabledApproveRej(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);
  //lotId,payTransferFee, showList

  const getGoDownRentFeeExtensionList = async (lotid) => {
    if (authenticated && lotid > 0) {
      await apiCallSPGet(
        `GoDownRentFeeExtension/SelectByLotId?LotId=${lotid}`,
        []
      ).then((res) => {
        if (res.success) {
          setGDRFEListData(res.data);
        }
      });
    }
  };

  const DownloadRefundReceipt = async (SrNo, RefundId) => {
    console.log(" SrNo: ", SrNo);
    const header = new Headers();
    const url = `LotDetails/DownloadRefundReceipt?SrNo=${SrNo}&RefundId=${RefundId}`;
    const fileName = SrNo + ".pdf";
    await apiDownloadDocument(fileName, url, "GET", header, null).then(
      (res) => {
        if (!res.success) alert(res.message);
        //else alert(res.message);
      }
    );
  };

  let refundScopedSlotsList = {
    download_Refund_lot_receipt: (item, index) => {
      return (
        <>
          <TableButtonClick
            buttonName={" Download Refund Receipt"}
            isDisplayAllow={
              //true
              item.refundReceiptFilePath !== "" &&
              item.refundReceiptFilePath !== null &&
              item.srno !== undefined
                ? true
                : false
            }
            onClick={() => DownloadRefundReceipt(item.srno, item.id)}
          />
        </>
      );
    },
  };
  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <ModalPaymentTransactionHistory
        key={"paymentTransactionHistoryLLR"}
        setshowpaymentHistory={setshowpaymentHistory}
        showpaymentHistory={showpaymentHistory}
        paymentTransactionHistory={paymentTransactionHistory}
        LotId={IdForPaymentHistory}
        paymentType={TypeForPaymentHistory}
        grfeId={0}
        setpaymentTransactionHistory={setpaymentTransactionHistory}
      />

      {!showList ? (
        <CSpinner
          className="spinner-grow col-6 offset-6 mt-6"
          color="success"
        />
      ) : (
        authenticated &&
        viewTenderDetails && (
          <CCardBody>
            <LotListViewLotDetails viewListDetails={viewListDetails} />

            <LotListViewLotDocument
              authenticated={authenticated}
              viewListDetails={viewListDetails}
              EmdPaid={EmdPaid}
              getLotDetails={getLotDetails}
              viewListDocument={viewListDocument}
            />

            {viewListDetails && viewListDetails.actualQuantity > 0 && (
              <LotListViewABS
                viewTenderDetails={viewTenderDetails}
                viewListDetails={viewListDetails}
                EmdPaid={EmdPaid}
                ABSPaymentDetails={ABSPaymentDetails}
                CPopUpId={CPopUpId}
                CPopUpIndex={CPopUpIndex}
                decrypted={decrypted}
                getLotDetails={getLotDetails}
                setToasts={setToasts}
                setABSPaymentDetails={setABSPaymentDetails}
              />
            )}

            <LotListViewTenderDetails viewTenderDetails={viewTenderDetails} />

            <div className="pl-1 pr-1">
              {viewPaymentSlotsData !== undefined &&
                viewPaymentSlotsData.length > 0 &&
                viewTenderDetails && (
                  <>
                    {[...Array(viewPaymentSlotsData.length)].map((e, i) => (
                      <>
                        <CRow>
                          <>
                            {viewPaymentSlotsData[i]?.type != -1 ? (
                              <>
                                {viewPaymentSlotsData[i].tenderPaymentSlotsId <=
                                -3 ? (
                                  <>
                                    <CCol className="mb-2 mt-2" xl={4}>
                                      <CLabel
                                        key={`Payment Due Date label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      >
                                        {viewPaymentSlotsData[i].displayLabel1}{" "}
                                        :
                                      </CLabel>
                                      <CInput
                                        key={`Payment Due Date input ${i + 1}`}
                                        value={
                                          viewPaymentSlotsData[i].dueDate ===
                                          null
                                            ? " "
                                            : formatDate(
                                                viewPaymentSlotsData[i].dueDate
                                              )
                                        }
                                        disabled
                                        id="exampleFormControlInput1"
                                      />
                                    </CCol>
                                    <CCol className="mb-2 mt-2" xl={2}>
                                      <CLabel
                                        key={`Addition SD AMT label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      >
                                        {viewPaymentSlotsData[i].displayLabel2}{" "}
                                        :
                                      </CLabel>
                                      <CInput
                                        key={`Addition SD AMT input ${i + 1}`}
                                        value={
                                          viewPaymentSlotsData[i].finalAmount
                                        }
                                        disabled
                                        id="exampleFormControlInput1"
                                      />
                                    </CCol>
                                    <CCol className="mb-2 mt-2" xl={2}>
                                      <CLabel
                                        key={`Addition SD AMT label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      ></CLabel>
                                    </CCol>
                                  </>
                                ) : (
                                  <>
                                    <CCol className="mb-2 mt-2" xl={4}>
                                      <CLabel
                                        key={`Payment Due Date label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      >
                                        {viewPaymentSlotsData[i].displayLabel1}{" "}
                                        :
                                      </CLabel>
                                      <CInput
                                        key={`Payment Due Date input ${i + 1}`}
                                        value={
                                          viewPaymentSlotsData[i].dueDate ===
                                          null
                                            ? " "
                                            : formatDate(
                                                viewPaymentSlotsData[i].dueDate
                                              )
                                        }
                                        disabled
                                        id="exampleFormControlInput1"
                                      />
                                    </CCol>
                                    <CCol className="mb-2 mt-2" xl={2}>
                                      <CLabel
                                        key={`Payment Complete label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      >
                                        {viewPaymentSlotsData[i].displayLabel2}{" "}
                                        :
                                      </CLabel>

                                      <CInput
                                        key={`Payment Complete input ${i + 1}`}
                                        value={
                                          viewPaymentSlotsData[i]
                                            .paymentComplete === 0
                                            ? " "
                                            : viewPaymentSlotsData[i]
                                                .paymentComplete
                                        }
                                        disabled
                                        id="exampleFormControlInput1"
                                      />
                                    </CCol>
                                    {/* {viewPaymentSlotsData[i]
                                    .isFinalSlotPaymentBeforeFirstInstallmentDueDate ==
                                  true
                                    ? "true"
                                    : "false"}
                                  -
                                  {
                                    viewPaymentSlotsData[i]
                                      .rebateOnFullPayment
                                  }{" "}
                                  -{(viewListDetails.purchasePrice * 2) / 100}{" "}
                                  -{" "}
                                  {viewPaymentSlotsData[i]
                                    .isSDAmountPaidOnline
                                    ? "true"
                                    : "false"}
                                  -{viewPaymentSlotsData[i].finalAmount}
                                  {viewPaymentSlotsData[i].finalAmount -
                                    Math.floor(
                                      (viewListDetails.purchasePrice * 2) /
                                        100
                                    ) +
                                    (viewPaymentSlotsData[i]
                                      .isSDAmountPaidOnline
                                      ? Math.ceil(
                                          (viewListDetails.purchasePrice *
                                            5) /
                                            100
                                        )
                                      : 0)} */}
                                    <CCol className="mb-2 mt-1" xl={2}>
                                      <CLabel
                                        key={`Payment Complete label ${i + 1}`}
                                        htmlFor="exampleFormControlInput1"
                                      >
                                        &nbsp;
                                      </CLabel>
                                      <CInput
                                        className={"mt-1"}
                                        key={`Payment percentage input ${
                                          i + 1
                                        }`}
                                        //className="mt-4"
                                        value={
                                          viewListDetails.actualQuantity > 0 &&
                                          !viewListDetails.isRequiredToReturnAdjustmentAmt
                                            ? viewPaymentSlotsData[i]
                                                .isFinalSlotPaymentBeforeFirstInstallmentDueDate &&
                                              viewPaymentSlotsData[i]
                                                .rebateOnFullPayment === 0
                                              ? viewPaymentSlotsData[i]
                                                  .finalAmount -
                                                Math.floor(
                                                  (viewListDetails.purchasePrice *
                                                    2) /
                                                    100
                                                ) +
                                                ((viewPaymentSlotsData[i]
                                                  .isSDAmountPaidOnline && (viewListDetails.collectionseason < 2026) )
                                                  ? Math.ceil(
                                                      (viewListDetails.purchasePrice *
                                                        5) /
                                                        100
                                                    )
                                                  : 0)
                                              : viewPaymentSlotsData[i]
                                                  .finalAmount
                                            : viewListDetails.actualQuantity > 0
                                            ? viewPaymentSlotsData[i]
                                                .finalAmount
                                            : viewPaymentSlotsData[i].amount
                                        }
                                        disabled
                                        id="exampleFormControlInput1"
                                      />
                                    </CCol>
                                  </>
                                )}
                                {/* { !viewPaymentSlotsData[i].isPayNowAllow ? "pay now not allowed":"Pay now allowed"} */}
                                {authenticated.role === "Bidder" &&
                                viewListDetails.lotTransferCount <= 2 &&
                                viewListDetails.status !== "Terminated" &&
                                ((EmdPaid.isEMDPaid === true &&
                                  viewListDetails.isAgreementAccepted === 1) ||
                                  viewListDetails.tenderType === 2 ||
                                  viewListDetails.tenderType === 3) &&
                                viewPaymentSlotsData[i].isPayNowAllow &&
                                viewTenderDetails.isAgreementLetterGenerated &&
                                EmdPaid.isSignedByCFO === true &&
                                !viewPaymentSlotsData[i].isFullPaymentDone ? (
                                  <CCol xl={4} className="mt-4 mb-2">
                                    {viewListDetails.actualQuantity > 0 &&
                                    viewPaymentSlotsData[i]
                                      .isABSPayment_TaxConsessionDone ? (
                                      <>
                                        <div
                                          style={{
                                            display: "inline-flex",
                                            marginTop: "0.625rem",
                                          }}
                                        >
                                          <CButton
                                            key={`Payment now ${i + 1}`}
                                            color="info"
                                            className="mr-2 ml-2"
                                            disabled={
                                              viewPaymentSlotsData[i]
                                                .isLastInstallment &&
                                              viewPaymentSlotsData[i]
                                                .installmentAdjustmentDate ===
                                                null && viewPaymentSlotsData[i].isFinalAdjustmentAmountButtonDisplay
                                                ? true
                                                : false
                                            }
                                            hidden={
                                              viewPaymentSlotsData[i]
                                                .finalAmount === 0
                                            }
                                            onClick={() => {
                                              if (
                                                viewPaymentSlotsData[i]
                                                  .isFinalSlotPaymentBeforeFirstInstallmentDueDate
                                              ) {
                                              
                                                  alert(
                                                    "Congratulations!!! You are paying all payment slots before first installment due date. You will get 2% rebate on purchase price."
                                                  );
                                             
                                                ConfirmationPopupHandler(
                                                  2,
                                                  1,
                                                  "Are you sure you want to proceed for Payment ?",
                                                  viewPaymentSlotsData[i]
                                                    .finalAmount,
                                                  viewPaymentSlotsData[i].id,
                                                  0,
                                                  viewPaymentSlotsData[i]
                                                    .totalSDAmount,
                                                  viewPaymentSlotsData[i]
                                                    .totalLateFees,
                                                  viewPaymentSlotsData[i]
                                                    .cgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .sgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .igstAmount,
                                                  0,
                                                  false,
                                                  ""
                                                );
                                               
                                              } else {
                                                ConfirmationPopupHandler(
                                                  2,
                                                  1,
                                                  "Are you sure you want to proceed for Payment?",
                                                  viewPaymentSlotsData[i]
                                                    .finalAmount,
                                                  viewPaymentSlotsData[i].id,
                                                  0,
                                                  0,
                                                  viewPaymentSlotsData[i]
                                                    .totalLateFees,
                                                  viewPaymentSlotsData[i]
                                                    .cgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .sgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .igstAmount,
                                                  0,
                                                  false,
                                                  ""
                                                );
                                              
                                              }
                                            }}
                                          >
                                            {viewPaymentSlotsData[i]
                                              .tenderPaymentSlotsId === -5
                                              ? "Pay Online"
                                              : "Pay Now"}
                                          </CButton>
                                          <CButton
                                            color="info"
                                            className="mr-2 ml-1"
                                            hidden={
                                              !viewPaymentSlotsData[i]
                                                .isAnyPaymentTransactionDone
                                            }
                                            // hidden={viewPaymentSlotsData[i].paidBy !== null && viewPaymentSlotsData[i].paidBy > 0 ? false : true}
                                            onClick={() =>
                                              ViewBankTransaction(
                                                viewPaymentSlotsData[i].id,
                                                "LT"
                                              )
                                            }
                                          >
                                            History
                                          </CButton>
                                          <CTooltip
                                            content="Click here to see full payment breakout."
                                            placement="top"
                                          >
                                            <CButton
                                              color="info"
                                              className="mr-2"
                                              onClick={() => {
                                                handleOpenPaymentBreakOut(
                                                  viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                                  viewPaymentSlotsData[i]
                                                    .finalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .cgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .sgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .igstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .accessBenefitSharingAmount,
                                                  viewPaymentSlotsData[i]
                                                    .add5PerOnFinalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .rebateOnFullPayment,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxAmount,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxConsessionPercentage,
                                                  viewListDetails.emdAmount_History ===
                                                    0
                                                    ? viewListDetails.emdAmount
                                                    : viewListDetails.emdAmount_History,
                                                  viewPaymentSlotsData[i]
                                                    .isSDAmountPaidOnline ===
                                                    true
                                                    ? viewPaymentSlotsData[i]
                                                        .addAmount
                                                    : 0,
                                                  viewListDetails.lotTransferCount ===
                                                    2
                                                    ? 0
                                                    : viewPaymentSlotsData[i]
                                                        .additionalSDAmount,
                                                  viewPaymentSlotsData[i]
                                                    .totalLateFees,
                                                  viewPaymentSlotsData[i]
                                                    .isLastInstallment,
                                                  viewPaymentSlotsData[i]
                                                    .installmentAdjustementAmount,
                                                  viewPaymentSlotsData[i]
                                                    .lastInstallmentPriceBreakUp,
                                                    viewPaymentSlotsData[i]
                                                    .totalSDAmount
                                                );
                                              }}
                                            >
                                              View
                                            </CButton>
                                          </CTooltip>
                                          <CButton
                                            className="mr-2 ml-2 float-right"
                                            color="success"
                                            hidden={
                                              viewPaymentSlotsData[i]
                                                .tenderPaymentSlotsId === -5
                                                ? false
                                                : true
                                            }
                                            disabled={
                                              viewPaymentSlotsData[i]
                                                .disableSD60BG
                                            }
                                            onClick={() =>
                                              BGPaymentHandler(
                                                viewListDetails.lotId,
                                                "AddInstallemntAmt"
                                              )
                                            }
                                          >
                                            Pay via Bank Guarantee
                                          </CButton>

                                          {/* <a
                                          target="_blank"
                                          href={`${downloadUrl}/${viewPaymentSlotsData[i].sD60BGFilePath}`}
                                        > */}
                                          <CButton
                                            color="info"
                                            className="mr-5 mt-1 float-right"
                                            hidden={
                                              viewPaymentSlotsData[i]
                                                .sD60BGFilePath != "" &&
                                              viewPaymentSlotsData[i]
                                                .sD60BGFilePath != null
                                                ? false
                                                : true
                                            }
                                            onClick={() =>
                                              BGPaymentStatusViewHanlder(
                                                viewPaymentSlotsData[i]
                                                  .sD60BGFilePath
                                              )
                                            }
                                          >
                                            View BG
                                          </CButton>
                                          {/* </a> */}
                                        </div>

                                        <div>
                                          {viewPaymentSlotsData[i]
                                            .sD60BGNotes &&
                                            viewPaymentSlotsData[
                                              i
                                            ].sD60BGNotes.trim() !== "" && (
                                              <>
                                                <br />
                                                <CLabel
                                                  className="mt-2 ml-3"
                                                  style={{
                                                    fontWeight: "600",
                                                  }}
                                                >
                                                  {
                                                    viewPaymentSlotsData[i]
                                                      .sD60BGNotes
                                                  }
                                                </CLabel>
                                              </>
                                            )}

                                          {viewPaymentSlotsData[i]
                                            .isLastInstallment &&
                                            viewPaymentSlotsData[i]
                                              .installmentAdjustmentDate ===
                                              null && viewPaymentSlotsData[i].
                                              isFinalAdjustmentAmountButtonDisplay                                               
                                              && (
                                              <CLabel
                                                className="mt-2 ml-3"
                                                style={{
                                                  fontWeight: "600",
                                                  color: "red",
                                                }}
                                                // hidden={
                                                //   viewPaymentSlotsData[i]
                                                //     .isLastInstallment &&
                                                //   viewPaymentSlotsData[i]
                                                //     .installmentAdjustmentDate ===
                                                //     null
                                                //     ? false
                                                //     : true
                                                // }
                                              >
                                                You can not pay final
                                                installment. DFO is yet to
                                                adjust final amount.
                                              </CLabel>
                                            )}
                                        </div>
                                      </>
                                    ) : (
                                      <CButton
                                        key={`Tax Consession ${i + 1}`}
                                        style={{
                                          width: "200px",
                                        }}
                                        className={"mt-2_5"}
                                        color="success"
                                        hidden={
                                          viewListDetails.actualQuantity > 0 &&
                                          FullPaymentLotDetails.isABSOptionSelected ===
                                            true
                                            ? viewPaymentSlotsData[i]
                                                .tenderPaymentSlotsId <= -3 &&
                                              viewPaymentSlotsData[i]
                                                .tenderPaymentSlotsId != -6
                                              ? true
                                              : false
                                            : true
                                        }
                                        disabled={
                                          (viewPaymentSlotsData[i]
                                            .isRequiedIncomeTaxConsession &&
                                            viewPaymentSlotsData[i]
                                              .isTaxConsessionApprovedByHO ===
                                              null &&
                                            viewPaymentSlotsData[i]
                                              ?.taxConsessionRejectionReason ===
                                              "") ||
                                          (viewPaymentSlotsData[i]
                                            .isRequiedIncomeTaxConsession &&
                                            viewPaymentSlotsData[i]
                                              .taxConsessionRejectionReason !==
                                              "" &&
                                            viewPaymentSlotsData[i]
                                              .isTaxConsessionApprovedByHO ===
                                              null)
                                            ? true
                                            : false
                                        }
                                        onClick={() =>
                                          handleOpenIncomeTaxConsessionPopup(
                                            viewListDetails.lotId,
                                            viewListDetails.lotNo,
                                            viewPaymentSlotsData[i].id,
                                            viewPaymentSlotsData[i]
                                              .isRequiedIncomeTaxConsession,
                                            viewPaymentSlotsData[i]
                                              .incomeTaxConsessionPercentage,
                                            viewPaymentSlotsData[i]
                                              .taxConsessionRejectionReason,
                                            viewPaymentSlotsData[i]
                                              .incomeTaxConsessionDocument,
                                            viewPaymentSlotsData[i]
                                              .isTaxConsessionApprovedByHO,
                                            viewPaymentSlotsData[i]
                                              .totalSDAmount,
                                            viewPaymentSlotsData[i]
                                              .isFinalSlotPaymentBeforeFirstInstallmentDueDate,
                                            viewPaymentSlotsData[i]
                                              .isSDAmountPaidOnline
                                          )
                                        }
                                      >
                                       Apply for Lower Deduction
                                      </CButton>
                                    )}
                                  </CCol>
                                ) : viewPaymentSlotsData[i].paidStatus ===
                                    "Success" &&
                                  viewPaymentSlotsData[i]?.paymentNotes !==
                                    "" &&
                                  !viewPaymentSlotsData[
                                    i
                                  ]?.paymentNotes?.includes("Challan") &&
                                  (viewPaymentSlotsData[i]?.tranId !== null ||
                                    viewPaymentSlotsData[i]?.type === 7) ? (
                                  <CCol xl={4} className="mt-4">
                                    {viewPaymentSlotsData[i]?.paymentNotes}{" "}
                                    <br />
                                    <CLabel
                                      className="mt-2"
                                      style={{ fontWeight: "600" }}
                                      hidden={
                                        viewPaymentSlotsData[i]
                                          .isLastInstallment &&
                                        viewPaymentSlotsData[i]
                                          .isSDAmountPaidOnline &&
                                        viewPaymentSlotsData[i]
                                          .add5PerOnFinalAmount > 0
                                          ? false
                                          : true
                                      }
                                    >
                                      Status of 5 % refund amount (
                                      {
                                        viewPaymentSlotsData[i]
                                          .add5PerOnFinalAmount
                                      }
                                      ) on full payment : &nbsp;
                                      {!viewListDetails.is5PerAmtRefundRequested
                                        ? "Not Requested"
                                        : viewListDetails.is5PerRefundApprovedByDFO
                                        ? "Approved by DFO and Refund Initiated"
                                        : "Pending for DFO Approval"}
                                    </CLabel>
                                    <div style={{ display: "inline-flex" }}>
                                      <CButton
                                        color="success"
                                        variant="outline"
                                        className="mr-5 ml-1 mb-1 float-right"
                                        hidden={
                                          authenticated.role === "Bidder" &&
                                          viewPaymentSlotsData[i]
                                            .isLastInstallment &&
                                          viewListDetails.is5PerAmtRefundRequested ===
                                            false &&
                                          viewPaymentSlotsData[i]
                                            .add5PerOnFinalAmount > 0 &&
                                          viewPaymentSlotsData[i]
                                            .isSDAmountPaidOnline
                                            ? false
                                            : true
                                        }
                                        onClick={
                                          Handler5PerRefunfRequestOnFullPayment
                                        }
                                      >
                                        Request for 5% Refund On Full Payment
                                      </CButton>
                                      <CButton
                                        color="info"
                                        className=" ml-2 mr-2 "
                                        hidden={
                                          //authenticated.role === "Bidder"  &&
                                          viewPaymentSlotsData[i]
                                            .isLastInstallment &&
                                          viewListDetails.is5PerAmtRefundRequested ===
                                            true &&
                                          IsSDRefunded5Per === true
                                            ? false
                                            : true
                                        }
                                        onClick={() => {
                                          ShowRefundHistory(
                                            viewListDetails.tenderId,
                                            viewListDetails.lotNo,
                                            4
                                          );
                                        }}
                                      >
                                        View Refund Status
                                      </CButton>
                                      <CButton
                                        color="info"
                                        onClick={() =>
                                          PaymentStatusViewHanlder(
                                            viewPaymentSlotsData[i]?.tranId
                                          )
                                        }
                                        hidden={
                                          viewPaymentSlotsData[i].tranId !=
                                            null &&
                                          viewPaymentSlotsData[i].tranId != ""
                                            ? false
                                            : true
                                        }
                                        className="mr-2 ml-2"
                                      >
                                        View Receipt
                                      </CButton>
                                      <CButton
                                        color="info"
                                        className="mr-2"
                                        hidden={
                                          viewPaymentSlotsData[i].tranId !=
                                            null &&
                                          viewPaymentSlotsData[i].tranId != ""
                                            ? false
                                            : true
                                        }
                                        style={{
                                          marginLeft: "5px",
                                        }}
                                        onClick={() =>
                                          ViewBankTransaction(
                                            viewPaymentSlotsData[i].id,
                                            "LT"
                                          )
                                        }
                                      >
                                        History
                                      </CButton>
                                      <CTooltip
                                        content="Click here to see full payment breakout."
                                        placement="top"
                                      >
                                        <CButton
                                          color="info"
                                          className="mr-2"
                                          onClick={() =>
                                            handleOpenPaymentBreakOut(                                            
                                               viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                              viewPaymentSlotsData[i]
                                                .finalAmount,
                                              viewPaymentSlotsData[i]
                                                .cgstAmount,
                                              viewPaymentSlotsData[i]
                                                .sgstAmount,
                                              viewPaymentSlotsData[i]
                                                .igstAmount,
                                              viewPaymentSlotsData[i]
                                                .accessBenefitSharingAmount,
                                              viewPaymentSlotsData[i]
                                                .add5PerOnFinalAmount,
                                              viewPaymentSlotsData[i]
                                                .rebateOnFullPayment,
                                              viewPaymentSlotsData[i]
                                                .incomeTaxAmount,
                                              viewPaymentSlotsData[i]
                                                .incomeTaxConsessionPercentage,
                                              viewListDetails.emdAmount_History ===
                                                0
                                                ? viewListDetails.emdAmount
                                                : viewListDetails.emdAmount_History,
                                              viewPaymentSlotsData[i]
                                                .isSDAmountPaidOnline === true
                                                ? viewPaymentSlotsData[i]
                                                    .addAmount
                                                : 0,
                                              viewListDetails.lotTransferCount ===
                                                2
                                                ? 0
                                                : viewPaymentSlotsData[i]
                                                    .additionalSDAmount,
                                              viewPaymentSlotsData[i]
                                                .totalLateFees,
                                              viewPaymentSlotsData[i]
                                                .isLastInstallment,
                                              viewPaymentSlotsData[i]
                                                .installmentAdjustementAmount,
                                              viewPaymentSlotsData[i]
                                                .lastInstallmentPriceBreakUp,
                                                viewPaymentSlotsData[i]
                                                .totalSDAmount
                                            )
                                          }
                                        >
                                          View
                                        </CButton>
                                      </CTooltip>

                                      <CButton
                                        color="info"
                                        className="mr-5 float-right mt-1 ml-1 "
                                        hidden={
                                          viewPaymentSlotsData[i]
                                            .sD60BGFilePath != "" &&
                                          viewPaymentSlotsData[i]
                                            .sD60BGFilePath != null
                                            ? false
                                            : true
                                        }
                                        onClick={() =>
                                          BGPaymentStatusViewHanlder(
                                            viewPaymentSlotsData[i]
                                              .sD60BGFilePath
                                          )
                                        }
                                      >
                                        View BG
                                      </CButton>
                                      {/* </div>
                                    <br />
                                    <div> */}
                                      <CButton
                                        key={`GenerateParidhanAadesh ${i + 1}`}
                                        color="success"
                                        variant="outline"
                                        className="mr-2 ml-2 float-right"
                                        // hidden={true}
                                        hidden={
                                          authenticated.role === "DFO" &&
                                          ABSPaymentDetails.isABSPaymentDone ===
                                            true &&
                                          (viewListDetails.godownRentPaymentTranId !==
                                            "" ||
                                            viewListDetails.tenderType === 2 ||
                                            viewListDetails.tenderType === 3) &&
                                          viewPaymentSlotsData[i]
                                            .tenderPaymentSlotsId > 0 &&
                                          viewPaymentSlotsData[i].paidStatus ===
                                            "Success" &&
                                          viewPaymentSlotsData[i]?.tranId !==
                                            null &&
                                          viewPaymentSlotsData[i]
                                            .pA_GodownName === ""
                                            ? false
                                            : true
                                        }
                                        onClick={() =>
                                          handleGenerateParidhanAadesh(
                                            viewPaymentSlotsData[i].id
                                          )
                                        }
                                      >
                                        Generate Paridhan Aadesh
                                      </CButton>
                                      {/* <CButton
                                    color="success"
                                    variant="outline"
                                    className="mr-2 ml-2 mt-2"
                                    onClick={() =>
                                      TestParidhanAadesh(
                                        viewPaymentSlotsData[i].id
                                      )
                                    }
                                  >
                                    Test Generate Paridhan Aadesh
                                  </CButton> */}
                                      {(authenticated.role === "DFO" ||
                                        authenticated.role === "Bidder") &&
                                        ABSPaymentDetails.isABSPaymentDone ===
                                          true &&
                                        viewPaymentSlotsData[i]
                                          .pA_GodownName !== "" && (
                                          <>
                                            <CButton
                                              color="info"
                                              className="mr-2 ml-2"
                                              disabled={
                                                viewPaymentSlotsData[i]
                                                  .pA_GodownName !== "" &&
                                                (viewListDetails.godownRentPaymentTranId !==
                                                  "" ||
                                                  viewListDetails.tenderType ===
                                                    2 ||
                                                  viewListDetails.tenderType ===
                                                    3)
                                                  ? false
                                                  : true
                                              }
                                              onClick={() =>
                                                handleDownloadParidhanAadesh(
                                                  viewPaymentSlotsData[i].id
                                                )
                                              }
                                            >
                                              Download Paridhan Aadesh
                                            </CButton>
                                            <br />
                                          </>
                                        )}
                                     
                                      
                                        <CLabel
                                          className="mt-2 ml-3"
                                          style={{
                                            fontWeight: "600",
                                            color: "red",
                                          }}
                                          hidden={
                                            (FullPaymentLotDetails.isABSOptionSelected ===
                                            true || viewPaymentSlotsData[i]?.isAdditionalSDPayment == true)
                                              ? true
                                              : false
                                          }
                                        >
                                          Please Select ABS Payment Option
                                        </CLabel>
                                     
                                      <br />
                                      <CLabel
                                        className="mt-2 ml-3 mt-2"
                                        style={{
                                          fontWeight: "600",
                                          color: "red",
                                        }}
                                        hidden={
                                          (authenticated.role === "DFO" ||
                                            authenticated.role === "Bidder") &
                                            (viewPaymentSlotsData[i]
                                              .pA_GodownName !==
                                              "") &&
                                          viewListDetails.tenderType === 1 &&
                                          viewListDetails.godownRentPaymentTranId ===
                                            ""
                                            ? false
                                            : true
                                        }
                                        // hidden={true}
                                      >
                                        {authenticated.role === "DFO"
                                          ? "Can not generate Paridhan Aadesh. Godown Rent Payment is Pending from bidder end."
                                          : "Can not download Paridhan Aadesh. Godown rent payment is pending."}
                                      </CLabel>
                                    </div>
                                  </CCol>
                                ) : authenticated.role === "Bidder" &&
                                  viewPaymentSlotsData[i]?.paymentNotes !==
                                    "" &&
                                  viewPaymentSlotsData[
                                    i
                                  ]?.paymentNotes?.includes("Challan") &&
                                  viewPaymentSlotsData[
                                    i
                                  ]?.paymentNotes?.includes("Awaiting") ? (
                                  <CCol xl={4} className="mt-4">
                                    {viewPaymentSlotsData[i]?.paymentNotes}{" "}
                                    <br />
                                    <CButton
                                      color="info"
                                      onClick={() =>
                                        PaymentStatusViewHanlder(
                                          viewPaymentSlotsData[i]?.tranId
                                        )
                                      }
                                      className="mr-2 mt-1 ml-1 float-right"
                                    >
                                      View Receipt
                                    </CButton>
                                    <CButton
                                      color="info"
                                      className="mr-2 mt-1 ml-1 float-right"
                                      onClick={() =>
                                        ViewBankTransaction(
                                          viewPaymentSlotsData[i].id,
                                          "LT"
                                        )
                                      }
                                    >
                                      History
                                    </CButton>
                                    <CTooltip
                                      content="Click here to see full payment breakout."
                                      placement="top"
                                    >
                                      <CButton
                                        color="info"
                                        className="mr-2 float-right"
                                        onClick={() =>
                                          handleOpenPaymentBreakOut(
                                         
                                                viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                            viewPaymentSlotsData[i].finalAmount,
                                            viewPaymentSlotsData[i].cgstAmount,
                                            viewPaymentSlotsData[i].sgstAmount,
                                            viewPaymentSlotsData[i].igstAmount,
                                            viewPaymentSlotsData[i]
                                              .accessBenefitSharingAmount,
                                            viewPaymentSlotsData[i]
                                              .add5PerOnFinalAmount,
                                            viewPaymentSlotsData[i]
                                              .rebateOnFullPayment,
                                            viewPaymentSlotsData[i]
                                              .incomeTaxAmount,
                                            viewPaymentSlotsData[i]
                                              .incomeTaxConsessionPercentage,
                                            viewListDetails.emdAmount_History ===
                                              0
                                              ? viewListDetails.emdAmount
                                              : viewListDetails.emdAmount_History,
                                            viewPaymentSlotsData[i]
                                              .isSDAmountPaidOnline === true
                                              ? viewPaymentSlotsData[i]
                                                  .addAmount
                                              : 0,
                                            viewListDetails.lotTransferCount ===
                                              2
                                              ? 0
                                              : viewPaymentSlotsData[i]
                                                  .additionalSDAmount,
                                            viewPaymentSlotsData[i]
                                              .totalLateFees,
                                            viewPaymentSlotsData[i]
                                              .isLastInstallment,
                                            viewPaymentSlotsData[i]
                                              .installmentAdjustementAmount,
                                            viewPaymentSlotsData[i]
                                              .lastInstallmentPriceBreakUp,
                                              viewPaymentSlotsData[i]
                                              .totalSDAmount
                                          )
                                        }
                                      >
                                        View
                                      </CButton>
                                    </CTooltip>
                                    <CButton
                                      color="info"
                                      onClick={() =>
                                        CancelChallanHanlder(
                                          viewPaymentSlotsData[i]?.paymentId
                                        )
                                      }
                                      className="mr-5 mt-1 ml-1 float-right"
                                    >
                                      Cancel Challan
                                    </CButton>
                                    <br></br>
                                    <CLabel
                                      className="mt-2 ml-3"
                                      style={{
                                        fontWeight: "600",
                                      }}
                                      hidden={
                                        viewPaymentSlotsData[i].sD60BGNotes !=
                                        ""
                                          ? false
                                          : true
                                      }
                                    >
                                      {viewPaymentSlotsData[i].sD60BGNotes}
                                    </CLabel>
                                    {/* <a
                                    target="_blank"
                                    href={`${downloadUrl}/${viewPaymentSlotsData[i].sD60BGFilePath}`}
                                  > */}
                                    <CButton
                                      color="info"
                                      className="mr-5 mt-1 float-right"
                                      hidden={
                                        viewPaymentSlotsData[i]
                                          .sD60BGFilePath != "" &&
                                        viewPaymentSlotsData[i]
                                          .sD60BGFilePath != null
                                          ? false
                                          : true
                                      }
                                      onClick={() =>
                                        BGPaymentStatusViewHanlder(
                                          viewPaymentSlotsData[i].sD60BGFilePath
                                        )
                                      }
                                    >
                                      View BG
                                    </CButton>
                                    {/* </a> */}
                                  </CCol>
                                ) : viewPaymentSlotsData[i]?.paymentNotes !==
                                    "" &&
                                  viewPaymentSlotsData[
                                    i
                                  ]?.paymentNotes?.includes("Challan") &&
                                  !viewPaymentSlotsData[
                                    i
                                  ]?.paymentNotes?.includes("Awaiting") ? (
                                  <CCol xl={4} className="mt-4">
                                    {viewPaymentSlotsData[i]?.paymentNotes}{" "}
                                    <br />
                                    <CLabel
                                      className="mt-2 ml-3"
                                      style={{ fontWeight: "600" }}
                                      hidden={
                                        viewPaymentSlotsData[i]
                                          .isLastInstallment &&
                                        viewPaymentSlotsData[i]
                                          .isSDAmountPaidOnline &&
                                        viewPaymentSlotsData[i]
                                          .add5PerOnFinalAmount > 0
                                          ? false
                                          : true
                                      }
                                    >
                                      Status of 5 % refund amount (
                                      {
                                        viewPaymentSlotsData[i]
                                          .add5PerOnFinalAmount
                                      }
                                      ) on full payment : &nsbp;
                                      {!viewListDetails.is5PerAmtRefundRequested
                                        ? "Not Requested"
                                        : viewListDetails.is5PerRefundApprovedByDFO
                                        ? "Approved by DFO and Refund Initiated"
                                        : "Pending for DFO Approval"}
                                    </CLabel>
                                    <div style={{ display: "inline-flex" }}>
                                      <CButton
                                        color="success"
                                        variant="outline"
                                        className="mr-5 mb-1 ml-1 float-right"
                                        hidden={
                                          authenticated.role === "Bidder" &&
                                          viewPaymentSlotsData[i]
                                            .isLastInstallment &&
                                          viewListDetails.is5PerAmtRefundRequested ===
                                            false &&
                                          viewPaymentSlotsData[i]
                                            .add5PerOnFinalAmount > 0 &&
                                          viewPaymentSlotsData[i]
                                            .isSDAmountPaidOnline
                                            ? false
                                            : true
                                        }
                                        onClick={
                                          Handler5PerRefunfRequestOnFullPayment
                                        }
                                      >
                                        Request for 5% Refund On Full Payment
                                      </CButton>
                                      <CButton
                                        color="info"
                                        className=" ml-2 mr-2 mb-2"
                                        hidden={
                                          authenticated.role === "Bidder" &&
                                          viewPaymentSlotsData[i]
                                            .isLastInstallment &&
                                          viewListDetails.is5PerAmtRefundRequested ===
                                            true &&
                                          IsSDRefunded5Per === true
                                            ? false
                                            : true
                                        }
                                        // hidden={
                                        //   viewListDetails.is5PerAmtRefundRequested ===
                                        //     true && IsSDRefunded5Per === true
                                        //     ? false
                                        //     : true
                                        // }
                                        onClick={() => {
                                          ShowRefundHistory(
                                            viewListDetails.tenderId,
                                            viewListDetails.lotNo,
                                            4
                                          );
                                        }}
                                      >
                                        View Refund Status
                                      </CButton>
                                      <CButton
                                        color="info"
                                        onClick={() =>
                                          PaymentStatusViewHanlder(
                                            viewPaymentSlotsData[i]?.tranId
                                          )
                                        }
                                        className="mr-2 ml-1 float-right"
                                      >
                                        View Receipt
                                      </CButton>
                                      <CButton
                                        color="info"
                                        className="mr-2 ml-1 float-right"
                                        onClick={() =>
                                          ViewBankTransaction(
                                            viewPaymentSlotsData[i].id,
                                            "LT"
                                          )
                                        }
                                      >
                                        History
                                      </CButton>
                                      <CTooltip
                                        content="Click here to see full payment breakout."
                                        placement="top"
                                      >
                                        <CButton
                                          color="info"
                                          className="mr-2 float-right"
                                          onClick={() =>
                                            handleOpenPaymentBreakOut(
                                               viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                              viewPaymentSlotsData[i]
                                                .finalAmount,
                                              viewPaymentSlotsData[i]
                                                .cgstAmount,
                                              viewPaymentSlotsData[i]
                                                .sgstAmount,
                                              viewPaymentSlotsData[i]
                                                .igstAmount,
                                              viewPaymentSlotsData[i]
                                                .accessBenefitSharingAmount,
                                              viewPaymentSlotsData[i]
                                                .add5PerOnFinalAmount,
                                              viewPaymentSlotsData[i]
                                                .rebateOnFullPayment,
                                              viewPaymentSlotsData[i]
                                                .incomeTaxAmount,
                                              viewPaymentSlotsData[i]
                                                .incomeTaxConsessionPercentage,
                                              viewListDetails.emdAmount_History ===
                                                0
                                                ? viewListDetails.emdAmount
                                                : viewListDetails.emdAmount_History,
                                              viewPaymentSlotsData[i]
                                                .isSDAmountPaidOnline === true
                                                ? viewPaymentSlotsData[i]
                                                    .addAmount
                                                : 0,
                                              viewListDetails.lotTransferCount ===
                                                2
                                                ? 0
                                                : viewPaymentSlotsData[i]
                                                    .additionalSDAmount,
                                              viewPaymentSlotsData[i]
                                                .totalLateFees,
                                              viewPaymentSlotsData[i]
                                                .isLastInstallment,
                                              viewPaymentSlotsData[i]
                                                .installmentAdjustementAmount,
                                              viewPaymentSlotsData[i]
                                                .lastInstallmentPriceBreakUp,
                                                viewPaymentSlotsData[i]
                                                .totalSDAmount
                                            )
                                          }
                                        >
                                          View
                                        </CButton>
                                      </CTooltip>
                                      <br></br>
                                      <CLabel
                                        className="mt-2 ml-3"
                                        style={{
                                          fontWeight: "600",
                                        }}
                                        hidden={
                                          viewPaymentSlotsData[i].sD60BGNotes !=
                                          ""
                                            ? false
                                            : true
                                        }
                                      >
                                        {viewPaymentSlotsData[i].sD60BGNotes}
                                      </CLabel>

                                      {/* <a
                                      target="_blank"
                                      href={`${downloadUrl}/${viewPaymentSlotsData[i].sD60BGFilePath}`}
                                    > */}
                                      <CButton
                                        color="info"
                                        className="mr-5 mt-1 float-right"
                                        hidden={
                                          viewPaymentSlotsData[i]
                                            .sD60BGFilePath != "" &&
                                          viewPaymentSlotsData[i]
                                            .sD60BGFilePath != null
                                            ? false
                                            : true
                                        }
                                        onClick={() =>
                                          BGPaymentStatusViewHanlder(
                                            viewPaymentSlotsData[i]
                                              .sD60BGFilePath
                                          )
                                        }
                                      >
                                        View BG
                                      </CButton>
                                      {/* </a> */}
                                    </div>
                                    <br />
                                    <div className="mt-2">
                                      {/* {i} -
                                      {viewPaymentSlotsData[i].paidStatus} -
                                      {viewPaymentSlotsData[i]?.paymentNotes}
                                      - {viewPaymentSlotsData[i]?.tranId} */}

                                      <CButton
                                        key={`GenerateParidhanAadesh ${i + 1}`}
                                        color="success"
                                        variant="outline"
                                        className="mr-2 ml-2 mt-2 float-right"
                                        hidden={
                                          authenticated.role === "DFO" &&
                                          ABSPaymentDetails.isABSPaymentDone ===
                                            true &&
                                          (viewListDetails.godownRentPaymentTranId !==
                                            "" ||
                                            viewListDetails.tenderType === 2 ||
                                            viewListDetails.tenderType === 3) &&
                                          viewPaymentSlotsData[i]
                                            .tenderPaymentSlotsId > 0 &&
                                          viewPaymentSlotsData[i].paidStatus ===
                                            "Success" &&
                                          viewPaymentSlotsData[i]?.tranId !==
                                            null &&
                                          viewPaymentSlotsData[i]
                                            .pA_GodownName === ""
                                            ? false
                                            : true
                                        }
                                        // hidden={true}
                                        onClick={() =>
                                          handleGenerateParidhanAadesh(
                                            viewPaymentSlotsData[i].id
                                          )
                                        }
                                      >
                                        Generate Paridhan Aadesh
                                      </CButton>
                                      <CButton
                                        color="info"
                                        className="mr-2 ml-2 float-right"
                                        hidden={
                                          (authenticated.role === "DFO" ||
                                            authenticated.role === "Bidder") &&
                                          ABSPaymentDetails.isABSPaymentDone ===
                                            true &&
                                          viewPaymentSlotsData[i]
                                            .pA_GodownName !== ""
                                            ? false
                                            : true
                                        }
                                        // hidden={true}
                                        disabled={
                                          viewPaymentSlotsData[i]
                                            .pA_GodownName !== "" &&
                                          (viewListDetails.godownRentPaymentTranId !==
                                            "" ||
                                            viewListDetails.tenderType === 2 ||
                                            viewListDetails.tenderType === 3)
                                            ? false
                                            : true
                                        }
                                        onClick={() =>
                                          handleDownloadParidhanAadesh(
                                            viewPaymentSlotsData[i].id
                                          )
                                        }
                                      >
                                        Download Paridhan Aadesh
                                      </CButton>
                                      <br />
                                      <br />
                                      <CLabel
                                        className="mt-2 ml-3"
                                        style={{
                                          fontWeight: "600",
                                          color: "red",
                                        }}
                                        hidden={
                                          (FullPaymentLotDetails.isABSOptionSelected ===
                                          true || viewPaymentSlotsData[i]?.isAdditionalSDPayment == true)
                                            ? true
                                            : false
                                        }
                                      >
                                        Please Select ABS Payment Option
                                      </CLabel>
                                      <br />
                                      <CLabel
                                        className="mt-2 ml-3 mt-2"
                                        style={{
                                          fontWeight: "600",
                                          color: "red",
                                        }}
                                        hidden={
                                          (authenticated.role === "DFO" ||
                                            authenticated.role === "Bidder") &
                                            (viewListDetails.tenderType === 1 &&
                                              viewPaymentSlotsData[i]
                                                .pA_GodownName !== "") &&
                                          viewListDetails.godownRentPaymentTranId ===
                                            ""
                                            ? false
                                            : true
                                        }
                                      >
                                        {authenticated.role === "DFO"
                                          ? "Can not generate Paridhan Aadesh. Godown Rent Payment is Pending from bidder end."
                                          : "Can not download Paridhan Aadesh. Godown rent payment is pending."}
                                      </CLabel>
                                    </div>
                                  </CCol>
                                ) : (
                                  authenticated.role !== "CGMF" && (
                                    <CCol xl={4} className="mt-4">
                                      {viewPaymentSlotsData[i]?.paymentNotes !==
                                        "" &&
                                      viewPaymentSlotsData[i]?.tranId !==
                                        null ? (
                                        <>
                                          <CButton
                                            color="info"
                                            onClick={() =>
                                              PaymentStatusViewHanlder(
                                                viewPaymentSlotsData[i]?.tranId
                                              )
                                            }
                                            className="mr-2 mt-1 ml-1 float-right"
                                          >
                                            View Receipt
                                          </CButton>
                                          <CButton
                                            color="info"
                                            className="mr-2 mt-1 ml-1 float-right"
                                            onClick={() =>
                                              ViewBankTransaction(
                                                viewPaymentSlotsData[i].id,
                                                "LT"
                                              )
                                            }
                                          >
                                            History
                                          </CButton>
                                          <CTooltip
                                            content="Click here to see full payment breakout."
                                            placement="top"
                                          >
                                            <CButton
                                              color="info"
                                              className="mr-2 float-right"
                                              onClick={() =>
                                                handleOpenPaymentBreakOut(
                                                  viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                                  viewPaymentSlotsData[i]
                                                    .finalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .cgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .sgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .igstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .accessBenefitSharingAmount,
                                                  viewPaymentSlotsData[i]
                                                    .add5PerOnFinalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .rebateOnFullPayment,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxAmount,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxConsessionPercentage,
                                                  viewListDetails.emdAmount_History ===
                                                    0
                                                    ? viewListDetails.emdAmount
                                                    : viewListDetails.emdAmount_History,
                                                  viewPaymentSlotsData[i]
                                                    .isSDAmountPaidOnline ===
                                                    true
                                                    ? viewPaymentSlotsData[i]
                                                        .addAmount
                                                    : 0,
                                                  viewListDetails.lotTransferCount ===
                                                    2
                                                    ? 0
                                                    : viewPaymentSlotsData[i]
                                                        .additionalSDAmount,
                                                  viewPaymentSlotsData[i]
                                                    .totalLateFees,
                                                  viewPaymentSlotsData[i]
                                                    .isLastInstallment,
                                                  viewPaymentSlotsData[i]
                                                    .installmentAdjustementAmount,
                                                  viewPaymentSlotsData[i]
                                                    .lastInstallmentPriceBreakUp,
                                                    viewPaymentSlotsData[i]
                                                    .totalSDAmount
                                                )
                                              }
                                            >
                                              View
                                            </CButton>
                                          </CTooltip>
                                          <CLabel
                                            className="mt-2 ml-3"
                                            style={{
                                              fontWeight: "600",
                                            }}
                                            hidden={
                                              viewPaymentSlotsData[i]
                                                .sD60BGNotes != ""
                                                ? false
                                                : true
                                            }
                                          >
                                            {
                                              viewPaymentSlotsData[i]
                                                .sD60BGNotes
                                            }
                                          </CLabel>

                                          {/* <a
                                          target="_blank"
                                          href={`${downloadUrl}/${viewPaymentSlotsData[i].sD60BGFilePath}`}
                                        > */}
                                          <CButton
                                            color="info"
                                            className="mr-5 mt-1 float-right"
                                            hidden={
                                              viewPaymentSlotsData[i]
                                                .sD60BGFilePath != "" &&
                                              viewPaymentSlotsData[i]
                                                .sD60BGFilePath != null
                                                ? false
                                                : true
                                            }
                                            onClick={() =>
                                              BGPaymentStatusViewHanlder(
                                                viewPaymentSlotsData[i]
                                                  .sD60BGFilePath
                                              )
                                            }
                                          >
                                            View BG
                                          </CButton>
                                          {/* </a> */}
                                        </>
                                      ) : authenticated.role === "DFO" &&
                                        viewListDetails.actualQuantity > 0 &&
                                        !viewPaymentSlotsData[i]
                                          .isFullPaymentDone &&
                                        viewPaymentSlotsData[i]
                                          .isLastInstallment &&
                                        viewPaymentSlotsData[i].isPayNowAllow &&
                                        viewPaymentSlotsData[i]
                                          .isFinalAdjustmentAmountButtonDisplay ? (
                                        <>
                                          <CTooltip
                                            content="Click here to see full payment breakout."
                                            placement="top"
                                          >
                                            <CButton
                                              color="info"
                                              className="mr-2 mt-2"
                                              onClick={() => {
                                                handleOpenPaymentBreakOut(
                                                   viewPaymentSlotsData[i]
                                              .paymentAmount ,
                                                  viewPaymentSlotsData[i]
                                                    .finalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .cgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .sgstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .igstAmount,
                                                  viewPaymentSlotsData[i]
                                                    .accessBenefitSharingAmount,
                                                  viewPaymentSlotsData[i]
                                                    .add5PerOnFinalAmount,
                                                  viewPaymentSlotsData[i]
                                                    .rebateOnFullPayment,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxAmount,
                                                  viewPaymentSlotsData[i]
                                                    .incomeTaxConsessionPercentage,
                                                  viewListDetails.emdAmount_History ===
                                                    0
                                                    ? viewListDetails.emdAmount
                                                    : viewListDetails.emdAmount_History,
                                                  viewPaymentSlotsData[i]
                                                    .isSDAmountPaidOnline ===
                                                    true
                                                    ? viewPaymentSlotsData[i]
                                                        .addAmount
                                                    : 0,
                                                  viewListDetails.lotTransferCount ===
                                                    2
                                                    ? 0
                                                    : viewPaymentSlotsData[i]
                                                        .additionalSDAmount,
                                                  viewPaymentSlotsData[i]
                                                    .totalLateFees,
                                                  viewPaymentSlotsData[i]
                                                    .isLastInstallment,
                                                  viewPaymentSlotsData[i]
                                                    .installmentAdjustementAmount,
                                                  viewPaymentSlotsData[i]
                                                    .lastInstallmentPriceBreakUp,
                                                    viewPaymentSlotsData[i]
                                                    .totalSDAmount
                                                );
                                              }}
                                            >
                                              View
                                            </CButton>
                                          </CTooltip>
                                          <CButton
                                            key={`AdjustAmt ${i + 1}`}
                                            color="success"
                                            variant="outline"
                                            className="mr-2 mt-2"
                                            // hidden={
                                            //   viewPaymentSlotsData[i]
                                            //     .isLastInstallment
                                            //     ? false
                                            //     : true
                                            // }
                                            disabled={
                                              viewPaymentSlotsData[i]
                                                .isLastInstallment &&
                                              viewPaymentSlotsData[i]
                                                .installmentAdjustmentDate !==
                                                null &&
                                              viewPaymentSlotsData[i]
                                                ?.installmentAdjustementAmount !==
                                                null
                                                ? true
                                                : false
                                            }
                                            onClick={() =>
                                              handleFinalInstallmentAdjustAmount(
                                                viewListDetails.lotNo,
                                                viewPaymentSlotsData[i].id,
                                                viewPaymentSlotsData[i]
                                                  .installmentAdjustementAmount,
                                                viewPaymentSlotsData[i]
                                                  .installmentAdjustmentDocument,
                                                viewPaymentSlotsData[i]
                                                  .comments,
                                                viewPaymentSlotsData[i]
                                                  .finalAmount
                                              )
                                            }
                                          >
                                            Adjust Final Installment Amount
                                          </CButton>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </CCol>
                                  )
                                )}
                              </>
                            ) : (
                              " "
                            )}
                          </>
                        </CRow>
                        {viewPaymentSlotsData[i].tenderPaymentSlotsId === -4 &&
                          !viewPaymentSlotsData[i].isSDPaidOnline && (
                            <CRow>
                              <CCol className="mb-2 mt-2" xl={12}>
                                <b> OR</b>
                              </CCol>
                            </CRow>
                          )}
                      </>
                    ))}
                  </>
                )}
              {/* {viewListDetails.is5PerAmtRefundRequested
                ? "requested"
                : "not requested"}{" "}
              -{" "}
              {FullPaymentLotDetails.isSDAmountPaidOnline
                ? "online"
                : "offline"}{" "}
              -
              {FullPaymentLotDetails.add5PerOnFinalAmount
                ? FullPaymentLotDetails.add5PerOnFinalAmount
                : 0} */}
              {/* Nikita: full Patment code */}
              {viewListDetails.actualQuantity > 0 &&
              viewListDetails.status !== "Terminated" &&
              viewTenderDetails?.isAgreementLetterGenerated &&
              EmdPaid.isSignedByCFO === true &&
              (viewListDetails.isAgreementAccepted === 1 ||
                viewListDetails.tenderType === 2 ||
                viewListDetails.tenderType === 3) ? (
                <CRow className="mt-3">
                  <CCol
                    style={{ textAlign: "right" }}
                    hidden={
                      FullPaymentLotDetails.isFullPaymentDone ||
                      FullPaymentLotDetails.isFullPayAllow
                        ? false
                        : true
                    }
                  >
                    Full payment with 2% discount will be :
                    <strong>
                      {viewListDetails.fullPaymentInstallmentAmount}
                    </strong>
                    {authenticated.role === "Bidder" &&
                    (FullPaymentLotDetails.isFullPayAllow ||
                      (viewListDetails.lotTransferCount === 2 &&
                        viewListDetails.isTransferFees_EMD_Visible)) &&
                    !FullPaymentLotDetails.isFullPaymentDone ? (
                      <>
                        <br />
                        {FullPaymentLotDetails.isABSPayment_TaxConsessionDone ? (
                          <>
                            <CTooltip
                              content="Click here to see full payment breakout."
                              placement="top"
                            >
                              <CButton
                                className="mr-2 mt-2"
                                color="info"
                                onClick={() =>
                                  handleOpenPaymentBreakOut(
                                    FullPaymentLotDetails.paymentAmount,
                                    FullPaymentLotDetails.finalAmount,
                                    FullPaymentLotDetails.cgstAmount,
                                    FullPaymentLotDetails.sgstAmount,
                                    FullPaymentLotDetails.igstAmount,
                                    FullPaymentLotDetails.accessBenefitSharingAmount,
                                    FullPaymentLotDetails.add5PerOnFinalAmount,
                                    FullPaymentLotDetails.rebateOnFullPayment,
                                    FullPaymentLotDetails.incomeTaxAmount,
                                    FullPaymentLotDetails.incomeTaxConsessionPercentage,
                                    viewListDetails.lotTransferCount === 2
                                      ? 0
                                      : viewListDetails.emdAmount_History === 0
                                      ? viewListDetails.emdAmount
                                      : viewListDetails.emdAmount_History,
                                    viewListDetails.lotTransferCount === 2
                                      ? 0
                                      : viewListDetails.isSDAmountPaidOnline ===
                                        true
                                      ? FullPaymentLotDetails.addAmount
                                      : 0,
                                    viewListDetails.lotTransferCount === 2
                                      ? 0
                                      : viewListDetails.additionalSecurityDepositeAmount,
                                    0,
                                    true,
                                    0,
                                    FullPaymentLotDetails.lastInstallmentPriceBreakUp,
                                    0
                                  )
                                }
                              >
                                View
                              </CButton>
                            </CTooltip>

                            <CButton
                              color="info"
                              onClick={
                                () =>
                                  ConfirmationPopupHandler(
                                    3,
                                    1,
                                    "Are you sure you want to proceed for Payment?",
                                    viewListDetails.fullPaymentInstallmentAmount,
                                    FullPaymentLotDetails.id,
                                    0,
                                    viewListDetails.additionalSDAmountForFinalPayment,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    false,
                                    ""
                                  )
                                // FullPaymentHanlder(
                                //   viewListDetails.fullPaymentInstallmentAmount,
                                //   FullPaymentLotDetails.id,
                                //   viewListDetails.additionalSDAmountForFinalPayment
                                // )
                              }
                              className="mr-3 mt-2 float-right"
                            >
                              Pay full payment
                            </CButton>

                            <CButton
                              color="info"
                              className="mr-2 mt-2 ml-2 float-right"
                              hidden={
                                !FullPaymentLotDetails.isAnyPaymentTransactionDone
                              }
                              // hidden={viewPaymentSlotsData[i].paidBy !== null && viewPaymentSlotsData[i].paidBy > 0 ? false : true}
                              onClick={() =>
                                ViewBankTransaction(
                                  FullPaymentLotDetails.id,
                                  "LT"
                                )
                              }
                            >
                              History
                            </CButton>
                            <br />
                            <CLabel
                              className="mt-2 ml-3"
                              style={{
                                fontWeight: "600",
                                color: "red",
                              }}
                              hidden={
                                FullPaymentLotDetails.isABSOptionSelected ===
                                true
                                  ? true
                                  : false
                              }
                            >
                              Please Select ABS Payment Option
                            </CLabel>
                          </>
                        ) : (
                          <>
                            {/* {FullPaymentLotDetails.isABSOptionSelected == true
                            ? "true"
                            : "false"} */}
                            <CButton
                              className={"mt-1 float-right"}
                              style={{
                                width: "200px",
                              }}
                              color="success"
                              hidden={
                                viewListDetails.actualQuantity > 0 &&
                                FullPaymentLotDetails.isABSOptionSelected ===
                                  true
                                  ? false
                                  : true
                              }
                              disabled={
                                (FullPaymentLotDetails.isRequiedIncomeTaxConsession &&
                                  FullPaymentLotDetails.isTaxConsessionApprovedByHO ===
                                    null &&
                                  FullPaymentLotDetails.taxConsessionRejectionReason ===
                                    "") ||
                                (FullPaymentLotDetails.isRequiedIncomeTaxConsession &&
                                  FullPaymentLotDetails.taxConsessionRejectionReason !==
                                    "" &&
                                  FullPaymentLotDetails.isTaxConsessionApprovedByHO ===
                                    null)
                                  ? true
                                  : false
                              }
                              onClick={() =>
                                handleOpenIncomeTaxConsessionPopup(
                                  viewListDetails.lotId,
                                  viewListDetails.lotNo,
                                  FullPaymentLotDetails.id,
                                  FullPaymentLotDetails.isRequiedIncomeTaxConsession,
                                  FullPaymentLotDetails.incomeTaxConsessionPercentage,
                                  FullPaymentLotDetails.taxConsessionRejectionReason,
                                  FullPaymentLotDetails.incomeTaxConsessionDocument,
                                  FullPaymentLotDetails.isTaxConsessionApprovedByHO,
                                  viewListDetails.additionalSDAmountForFinalPayment,
                                  true,
                                  viewListDetails.isSDAmountPaidOnline
                                )
                              }
                            >
                              Apply for Lower Deduction
                            </CButton>
                          </>
                        )}
                      </>
                    ) : FullPaymentLotDetails.isFullPaymentDone &&
                      FullPaymentLotDetails?.paymentNotes !== "" &&
                      !FullPaymentLotDetails?.paymentNotes?.includes(
                        "Challan"
                      ) &&
                      FullPaymentLotDetails?.tranId !== null ? (
                      <>
                        {/*Nikita: 5 per rebate starts here*/}
                        <br />
                        <div style={{ width: "100%" }} className="float-right">
                          <CLabel
                            className=" ml-3"
                            style={{ fontWeight: "600" }}
                            hidden={
                              viewListDetails.isSDAmountPaidOnline &&
                              FullPaymentLotDetails.add5PerOnFinalAmount > 0
                                ? false
                                : true
                            }
                          >
                            Status of 5 % refund amount (
                            {FullPaymentLotDetails.add5PerOnFinalAmount}) on
                            full payment : &nbsp;
                            {!viewListDetails.is5PerAmtRefundRequested
                              ? "Not Requested"
                              : viewListDetails.is5PerRefundApprovedByDFO
                              ? "Approved by DFO and Refund Initiated"
                              : "Pending for DFO Approval"}
                          </CLabel>
                        </div>
                        <br />
                        {/*5 per rebate ends here*/}
                        <div style={{ width: "100%" }} className="float-right">
                          <CButton
                            color="success"
                            variant="outline"
                            className="mr-5 mb-2"
                            // disabled={viewListDetails.is5PerAmtRefundRequested === true
                            //   ? true
                            //   : false
                            //   }
                            hidden={
                              authenticated.role === "Bidder" &&
                              viewListDetails.is5PerAmtRefundRequested ===
                                false &&
                              viewListDetails.isSDAmountPaidOnline &&
                              FullPaymentLotDetails.add5PerOnFinalAmount > 0
                                ? false
                                : true
                            }
                            onClick={Handler5PerRefunfRequestOnFullPayment}
                          >
                            Request for 5% Refund On Full Payment
                          </CButton>
                          <CButton
                            color="info"
                            className=" ml-2 mr-2 mb-2"
                            hidden={
                              authenticated.role === "Bidder" &&
                              viewListDetails.is5PerAmtRefundRequested ===
                                true &&
                              IsSDRefunded5Per === true
                                ? false
                                : true
                            }
                            // hidden={
                            //   viewListDetails.is5PerAmtRefundRequested ===
                            //     true && IsSDRefunded5Per === true
                            //     ? false
                            //     : true
                            // }
                            onClick={() => {
                              ShowRefundHistory(
                                viewListDetails.tenderId,
                                viewListDetails.lotNo,
                                4
                              );
                            }}
                          >
                            View Refund Status
                          </CButton>
                          <CButton
                            color="info"
                            className="float-right ml-1"
                            onClick={() =>
                              PaymentStatusViewHanlder(
                                FullPaymentLotDetails?.tranId
                              )
                            }
                          >
                            View Receipt
                          </CButton>
                          <CButton
                            color="info"
                            className="float-right ml-1"
                            onClick={() =>
                              ViewBankTransaction(
                                FullPaymentLotDetails.id,
                                "LT"
                              )
                            }
                          >
                            History
                          </CButton>
                          <CTooltip
                            content="Click here to see full payment breakout."
                            placement="top"
                          >
                            <CButton
                              color="info"
                              className="mr-2 float-right"
                              onClick={() =>
                                handleOpenPaymentBreakOut(
                                  FullPaymentLotDetails.paymentAmount,
                                  FullPaymentLotDetails.finalAmount,
                                  FullPaymentLotDetails.cgstAmount,
                                  FullPaymentLotDetails.sgstAmount,
                                  FullPaymentLotDetails.igstAmount,
                                  FullPaymentLotDetails.accessBenefitSharingAmount,
                                  FullPaymentLotDetails.add5PerOnFinalAmount,
                                  FullPaymentLotDetails.rebateOnFullPayment,
                                  FullPaymentLotDetails.incomeTaxAmount,
                                  FullPaymentLotDetails.incomeTaxConsessionPercentage,
                                  viewListDetails.lotTransferCount === 2? 0:viewListDetails.emdAmount_History === 0
                                    ? viewListDetails.emdAmount
                                    : viewListDetails.emdAmount_History,
                                    viewListDetails.lotTransferCount === 2? 0:viewListDetails.isSDAmountPaidOnline === true
                                    ? FullPaymentLotDetails.addAmount
                                    : 0,
                                  viewListDetails.lotTransferCount === 2
                                    ? 0
                                    : viewListDetails.additionalSecurityDepositeAmount,
                                  0,
                                  true,
                                  0,
                                  FullPaymentLotDetails.lastInstallmentPriceBreakUp,
                                  0
                                )
                              }
                            >
                              View
                            </CButton>
                          </CTooltip>
                        </div>
                        <br />
                        <div className="mt-2">
                          <CButton
                            key="paridhanadesh"
                            color="success"
                            variant="outline"
                            className="mr-2 ml-2 mt-2 float-right"
                            hidden={
                              authenticated.role === "DFO" &&
                              ABSPaymentDetails.isABSPaymentDone === true &&
                              viewListDetails.godownRentPaymentTranId !== "" &&
                              FullPaymentLotDetails.paidStatus === "Success" &&
                              FullPaymentLotDetails.tranId !== null &&
                              (viewListDetails.godownRentPaymentId > 0 ||
                                viewListDetails.tenderType === 2 ||
                                viewListDetails.tenderType === 3) &&
                              FullPaymentLotDetails.pA_GodownName === ""
                                ? false
                                : true
                            }
                            // hidden={true}
                            onClick={() =>
                              handleGenerateParidhanAadesh(
                                FullPaymentLotDetails.id
                              )
                            }
                          >
                            Generate Paridhan Aadesh
                          </CButton>
                          <CButton
                            className="mr-2 ml-2 float-right"
                            color="info"
                            hidden={
                              (authenticated.role === "DFO" ||
                                authenticated.role === "Bidder") &&
                              ABSPaymentDetails.isABSPaymentDone === true &&
                              FullPaymentLotDetails.pA_GodownName !== ""
                                ? false
                                : true
                            }
                            // hidden={true}
                            disabled={
                              FullPaymentLotDetails.pA_GodownName !== "" &&
                              (viewListDetails.godownRentPaymentTranId !== "" ||
                                viewListDetails.tenderType === 2 ||
                                viewListDetails.tenderType === 3)
                                ? false
                                : true
                            }
                            onClick={() =>
                              handleDownloadParidhanAadesh(
                                FullPaymentLotDetails.id
                              )
                            }
                          >
                            Download Paridhan Aadesh
                          </CButton>
                          <br />
                          <CLabel
                            className="mt-2 ml-3"
                            style={{
                              fontWeight: "600",
                              color: "red",
                            }}
                            hidden={
                              FullPaymentLotDetails.isABSOptionSelected === true
                                ? true
                                : false
                            }
                          >
                            Please Select ABS Payment Option
                          </CLabel>
                          <br />
                          <CLabel
                            className="mt-2 ml-3 mt-2"
                            style={{ fontWeight: "600", color: "red" }}
                            hidden={
                              (authenticated.role === "DFO" ||
                                authenticated.role === "Bidder") &&
                              FullPaymentLotDetails.pA_GodownName !== "" &&
                              viewListDetails.tenderType === 1 &&
                              viewListDetails.godownRentPaymentTranId === ""
                                ? false
                                : true
                            }
                          >
                            {authenticated.role === "DFO"
                              ? "Can not generate Paridhan Aadesh. Godown Rent Payment is Pending from bidder end."
                              : "Can not download Paridhan Aadesh. Godown rent payment is pending."}
                          </CLabel>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </CCol>
                </CRow>
              ) : (
                ""
              )}
              {/*Fullpayment ends here */}
              {/* Adjustment Refund Note* for bidder*/}
              {viewListDetails.actualQuantity > 0 &&
                authenticated.role === "Bidder" &&
                viewListDetails.isRequiredToReturnAdjustmentAmt && (
                  <LotListViewBidderRefundInstallmentAdjustment
                    viewListDetails={viewListDetails}
                    ShowRefundHistory={ShowRefundHistory}
                  />
                )}
            </div>
            {/*Lot Transfer Details*/}
            {viewTransferDetails.length > 0 && (
              <LotListViewTransferDetails
                decrypted={decrypted}
                viewListDetails={viewListDetails}
                viewTransferDetails={viewTransferDetails}
                viewPaymentDetails={viewPaymentDetails}
                BGPaymentStatusViewHanlder={BGPaymentStatusViewHanlder}
                PaymentStatusViewHanlder={PaymentStatusViewHanlder}
              />
            )}
            {/* Start Transfer EMD Refund 
              Start Refund Installment Adjustment Amount 
            Start 5 % Security Deposite Refund **/}
            {viewListDetails?.lotId > 0 && (
              <LotListViewTransferRefund
                viewListDetails={viewListDetails}
                viewPaymentSlotsData={viewPaymentSlotsData}
                FullPaymentLotDetails={FullPaymentLotDetails}
                ShowRefundHistory={ShowRefundHistory}
                showEMDRefundButton={showEMDRefundButton}
                RefundConfirmationPopupHandler={RefundConfirmationPopupHandler}
                disableInstallmentAdjustment={disableInstallmentAdjustment}
                disable5PerRefundButton={disable5PerRefundButton}
                IsSDRefunded5Per={IsSDRefunded5Per}
                disableEMDRefundButton={disableEMDRefundButton}
                disableSDRefundButton={disableSDRefundButton}
                IsSDRefunded={IsSDRefunded}
                handleOpenBGRefundPopup={handleOpenBGRefundPopup}
                disable25PerSDRefund={disable25PerSDRefund}
              />
            )}

            {viewListDetails?.lotId > 0 && (
              <LotListViewGoDownRent
                viewListDetails={viewListDetails}
                ViewBankTransaction={ViewBankTransaction}
                PaymentStatusViewHanlder={PaymentStatusViewHanlder}
                ConfirmationPopupHandler={ConfirmationPopupHandler}
              />
            )}

            {viewListDetails.lotId > 0 &&
              GDRFEListData &&
              GDRFEListData.length > 0 && (
                <LotListViewGoDownRentFeeExtension
                  getGoDownRentFeeExtensionList={getGoDownRentFeeExtensionList}
                  viewListDetails={viewListDetails}
                  GDRFEListData={GDRFEListData}
                  ViewBankTransaction={ViewBankTransaction}
                  PaymentStatusViewHanlder={PaymentStatusViewHanlder}
                  ConfirmationPopupHandler={ConfirmationPopupHandler}
                  setpaymentTransactionHistory={setpaymentTransactionHistory}
                  setshowpaymentHistory={setshowpaymentHistory}
                  setTypeForPaymentHistory={setTypeForPaymentHistory}
                  setIdForPaymentHistory={setIdForPaymentHistory}
                />
              )}

            <LotListViewEMDAndSecurityDepositPayment
              lotId={lotId}
              EmdPaid={EmdPaid}
              viewListDetails={viewListDetails}
              viewTenderDetails={viewTenderDetails}
              viewTransferDetails={viewTransferDetails}
              ViewBankTransaction={ViewBankTransaction}
              PaymentStatusViewHanlder={PaymentStatusViewHanlder}
              BGPaymentStatusViewHanlder={BGPaymentStatusViewHanlder}
              BGPaymentHandler={BGPaymentHandler}
              CancelChallanHanlder={CancelChallanHanlder}
              ConfirmationPopupHandler={ConfirmationPopupHandler}
            />

            {authenticated.role === "Bidder" &&
              viewListDetails.isTransferFeePaidStatusSuccess === true &&
              viewListDetails.lotTransferCount === 1 && (
                <LotListViewTransferLotEMDPayment
                  viewListDetails={viewListDetails}
                  FullPaymentLotDetails={FullPaymentLotDetails}
                  ConfirmationPopupHandler={ConfirmationPopupHandler}
                  PaymentStatusViewHanlder={PaymentStatusViewHanlder}
                  TransferLotEMDPayment={TransferLotEMDPayment}
                  BGPaymentStatusViewHanlder={BGPaymentStatusViewHanlder}
                />
              )}

            <LotListViewTransferButton
              lotId={lotId}
              isAnyPaidSlots={isAnyPaidSlots}
              viewListDetails={viewListDetails}
              viewTenderDetails={viewTenderDetails}
              viewTransferDetails={viewTransferDetails}
            />

            {viewListDetails &&
            viewTenderDetails &&
            authenticated.role === "Bidder" &&
            viewTenderDetails?.isSanctionLetterGenerated &&
            viewListDetails.isSanctionAccepted === 0 &&
            viewTransferDetails.length === 0 ? (
              <>
                <a
                  href={`${apiCall.downloadUrl}/${viewListDetails?.sanctionLetterPath}`}
                  target="_blank"
                  className=""
                  rel="noreferrer"
                >
                  <CButton className="mt-5 mr-2" color="success">
                    View Sanction Letter
                  </CButton>
                </a>
                <CButton
                  className="mt-2"
                  color="success"
                  variant="outline"
                  onClick={() => updateSanction(1)}
                >
                  Accept Sanction
                </CButton>
                <CButton
                  className="mt-2 ml-2 mr-2"
                  color="danger"
                  variant="outline"
                  onClick={() => updateSanction(2)}
                >
                  Reject Sanction
                </CButton>
              </>
            ) : viewListDetails &&
              viewTenderDetails &&
              authenticated.role === "Bidder" &&
              viewTenderDetails?.isSanctionLetterGenerated &&
              viewPaymentDetails.length > 0 &&
              viewTransferDetails[viewTransferDetails.length - 1]?.status !==
                0 &&
              viewPaymentDetails[viewPaymentDetails.length - 1]?.status === 1 &&
              viewListDetails.isSanctionAccepted === 0 &&
              viewPaymentDetails[viewPaymentDetails.length - 1]?.paidByUser !==
                null ? (
              <>
                <a
                  href={`${apiCall.downloadUrl}/${viewListDetails?.sanctionLetterPath}`}
                  target="_blank"
                  className=""
                  rel="noreferrer"
                >
                  <CButton className="mt-5 mr-2" color="success">
                    View Sanction Letter
                  </CButton>
                </a>
                <CButton
                  className="mt-2"
                  color="success"
                  variant="outline"
                  onClick={() => updateSanction(1)}
                >
                  Accept Sanction
                </CButton>
                <CButton
                  className="mt-2 ml-2 mr-2"
                  color="danger"
                  variant="outline"
                  onClick={() => updateSanction(2)}
                >
                  Reject Sanction
                </CButton>
              </>
            ) : (
              ""
            )}

            {/* Nikita: {Check if 7 day extention is allowed afetr lot transfer or not} */}
            {authenticated.role === "Bidder" && (
              <LotListViewAgrement
                lotId={lotId}
                EmdPaid={EmdPaid}
                viewListDetails={viewListDetails}
                viewTransferDetails={viewTransferDetails}
                setshowList={setshowList}
                decrypted={decrypted}
                getLotDetails={getLotDetails}
              />
            )}

            <LotListViewDownloadAgreementAndTransferLetter
              EmdPaid={EmdPaid}
              viewListDetails={viewListDetails}
              viewTenderDetails={viewTenderDetails}
              viewTransferDetails={viewTransferDetails}
            />
           {/*  { EmdPaid.isEMDPaid === false ? "Emd not paid" : "EMD Paid"}
            {viewListDetails.isAgreementAllowed ? "Allowed" : "Not allowed"}
            {!viewListDetails.isLotLeftRequest ? "LotLeft false" : "LotLeft true"}
            { {viewListDetails.IsLotLeftHOApproval === true ? "true" : "false"} } */}
            
            {(
              viewListDetails.isLotLeftRequest ===true ||
              (viewListDetails.tenderType === 1 || 
            viewListDetails.tenderType === 2 && viewListDetails.isAgreementAllowed)&&
              //  (viewListDetails.isLotLeftRequest === false || viewListDetails.IsLotLeftHOApproval === true) &&
              authenticated.role === "Bidder" &&
              EmdPaid.isEMDPaid === false &&
              viewListDetails.lotTransferCount === 0) && (
                <LotListViewLotLeftRequest
                  viewListDetails={viewListDetails}
                  EmdPaid={EmdPaid}
                  setToasts={setToasts}
                  toasts={toasts}
                  PaymentStatusViewHanlder={PaymentStatusViewHanlder}
                />
              )}

            {viewListDetails.isAdHocPayment === true && (
              <LotListViewAdHocPayment
                viewListDetails={viewListDetails}
                EmdPaid={EmdPaid}
                setToasts={setToasts}
                toasts={toasts}
                PaymentStatusViewHanlder={PaymentStatusViewHanlder}
                ConfirmationPopupHandler={ConfirmationPopupHandler}
                setpaymentTransactionHistory={setpaymentTransactionHistory}
                setshowpaymentHistory={setshowpaymentHistory}
                setTypeForPaymentHistory={setTypeForPaymentHistory}
                setIdForPaymentHistory={setIdForPaymentHistory}
              />
            )}

            <CButton
              className="mt-4 mb-4"
              color="dark"
              onClick={() => history.goBack()}
            >
              Go Back
            </CButton>

            {viewListDetails?.day7ExtentionNotes ? (
              <>
                <br />
                <strong>7 Day Extention: </strong>
                {viewListDetails?.day7ExtentionNotes}
                <CButton
                  color="info"
                  onClick={() =>
                    PaymentStatusViewHanlder(viewListDetails?.day7paymenttranId)
                  }
                  className="mr-5 mt-1 ml-2"
                >
                  View Receipt
                </CButton>
                <strong>CCF status : </strong> {viewListDetails?.day7Status}
              </>
            ) : (
              ""
            )}
            {viewListDetails?.march15ExtentionNotes ? (
              <>
                <br />
                <strong>Second Extention: </strong>
                {viewListDetails?.march15ExtentionNotes}
                <CButton
                  color="info"
                  onClick={() =>
                    PaymentStatusViewHanlder(
                      viewListDetails?.secondExtentionpaymenttranId
                    )
                  }
                  className="mr-5 mt-1 ml-2"
                >
                  View Receipt
                </CButton>
                <strong>HO status: </strong> :
                {viewListDetails?.secondExtentionStatus}
              </>
            ) : (
              ""
            )}
            {isAnyPaidSlots > 0 &&
            (authenticated.role === "CFO" || authenticated.role === "DFO") ? (
              <>
                <CButton
                  className="mt-5 ml-3"
                  color="success"
                  variant="outline"
                  hidden="true"
                  onClick={() => generateAadeshLetter()}
                >
                  Generate Paridhan Aadesh
                </CButton>
              </>
            ) : (
              ""
            )}

            <LotListViewFooter
              viewListDetails={viewListDetails}
              viewTenderDetails={viewTenderDetails}
              viewTransferDetails={viewTransferDetails}
              EmdPaid={EmdPaid}
            />

            <div>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={modalstyle} elevation={3}>
                  <CForm className="needs-validation" onSubmit={terminateLot}>
                    <CRow>
                      <CCol>
                        <CLabel>Reason for termination:</CLabel>
                        <CTextarea
                          onChange={(e) => setterminationMsg(e.target.value)}
                          required
                        />
                      </CCol>
                    </CRow>
                    <CRow
                      style={{
                        marginLeft: "7rem",
                      }}
                    >
                      <CCol>
                        <CButton className="mt-3" color="success" type="submit">
                          Terminate
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
            <div>
              <CustomeModalPopup
                onOpen={IncomeTaxConsessionOpen}
                onClose={handleIncomeTaxConsessionClose}
                onSubmitButton={HandlerTaxConsessionSubmit}
                onCloseButton={handleIncomeTaxConsessionClose}
                isSubmitBtnDisabled={false}
                isFromSubmit={true}
                popupWith={520}
                btnCColstyle={{ textAlign: "right" }}
                body={
                  <>
                    <CRow>
                      <CCol>
                        <CLabel>Lot No. : {IncomeTaxConsessionLotNo}</CLabel>
                      </CCol>
                    </CRow>
                    <hr />
                    {/* <CRow className="mb-3">
                <CCol xl={1}>
                  <input
                    id="chkIsViewOnly"
                    placeholder=""
                    type="checkbox"
                    style={{ marginRight: "10px" }}
                    checked={IsTaxConsessionRequired ? true : false}
                    onChange={(e) => {
                      setIsTaxConsessionRequired(e.target.checked);
                    }}
                  ></input>
                </CCol>
                <CCol xl={11}>
                  <CLabel>
                    Do you want to take Income Tax Concession from 0% to
                    5%? if No then by default it will consider 5%
                  </CLabel>
                </CCol>
              </CRow> */}
                    {/* {IsTaxConsessionRequired === true ? (
                <> */}
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Payable IncomeTax in Percentage (0 - 2)</CLabel>
                        <CInput
                          required
                          value={TaxConsessionPer}
                          step="any"
                          style={{
                            display: "inline",
                            width: "100px",
                            marginLeft: "10px",
                          }}
                          onChange={(e) => {
                            setTaxConsessionPer(e.target.value);
                          }}
                          id="taxconsPer"
                          presicion={2}
                          min={0.0}
                          max={2.0}
                          type="number"
                          invalid={TaxConsessionPer === "" ? true : false}
                        />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Upload Letter</CLabel>
                        <input
                          name="file"
                          id="taxconsessiondoc"
                          type="file"
                          accept=".pdf"
                          style={{ display: "inline", marginLeft: "20px" }}
                          onChange={(e) => {
                            setTaxConsessionFileEvent(e);
                            setTaxConsessionSelectedFile(e.target.files[0]);
                            e.preventDefault();
                          }}
                        />
                         <CLabel>Upload concession letter of instruction by HO and Income tax concession certificate</CLabel>
                      </CCol>
                    </CRow>
                   

                    {!IsTaxConsessionApprovedByHO && RejectionReason !== "" ? (
                      <>
                        <CLabel>Reason for Rejection </CLabel>
                        <CTextarea
                          id="txtrejectionreason"
                          value={RejectionReason}
                          disabled
                        />
                      </>
                    ) : (
                      ""
                    )}
                    <hr />
                  </>
                }
                footerBeforeBtn={
                  <>
                    {TaxConsessionDocument !== null &&
                    TaxConsessionDocument !== "" ? (
                      <CButton
                        className="mt-1 mr-2"
                        color="success"
                        onClick={() =>
                          handleDownloadTaxConsessionDocument(
                            IncomeTaxConsessionLotId,
                            LotPymentIdForIncomeTaxPay
                          )
                        }
                      >
                        Download Letter
                      </CButton>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
            {/* Final1 Installment Adjustment */}
            <div>
              <>
                <CustomeModalPopup
                  onOpen={InstallmentAdjustmentOpen}
                  onClose={handleInstallmentAdjustmentClose}
                  onSubmitButton={HandlerInstallmentAdjustmentSubmit}
                  onCloseButton={handleInstallmentAdjustmentClose}
                  popupWith={520}
                  isFromSubmit={true}
                  body={
                    <>
                      <CRow>
                        <CCol>
                          <CLabel>LotNo: {InstallmentAdjustLotNo}</CLabel>
                        </CCol>
                      </CRow>

                      <hr />
                      <CRow className="mb-3">
                        <CCol xl={12}>
                          <CLabel>Adjustment Amount:</CLabel>
                          <CInput
                            required
                            value={InstallmentAdjustAmount}
                            style={{
                              display: "inline",
                              width: "100px",
                              marginLeft: "10px",
                            }}
                            min={InstallmentAdjustLotNoAmountMin}
                            onChange={(e) => {
                              setInstallmentAdjustAmount(e.target.value);
                            }}
                            id="adjustAmt"
                            step="any"
                            presicion={2}
                            type="number"
                            invalid={
                              InstallmentAdjustAmount === "" ? true : false
                            }
                          />
                        </CCol>
                      </CRow>
                      <CRow className="mb-3">
                        <CCol>
                          <CLabel>Upload Document:</CLabel>
                          <input
                            name="file"
                            id="adjustmentdoc"
                            type="file"
                            accept=".pdf"
                            style={{ display: "inline", marginLeft: "20px" }}
                            onChange={(e) => {
                              setInstallmentAdjustmentFileEvent(e);
                              setInstallmentAdjustmentFile(e.target.files[0]);
                              e.preventDefault();
                            }}
                          />
                        </CCol>
                      </CRow>
                      <CLabel>Comments: </CLabel>
                      <CTextarea
                        id="txtcomments"
                        value={InstallmentAdjustComments}
                        required
                        onChange={(e) => {
                          setInstallmentAdjustComments(e.target.value);
                        }}
                        invalid={
                          InstallmentAdjustComments === "" ? true : false
                        }
                      />
                      <hr />
                    </>
                  }
                  footerBeforeBtn={
                    InstallmentAdjustDocument !== null &&
                    InstallmentAdjustDocument !== "" && (
                      <CButton
                        className="mt-3"
                        color="success"
                        onClick={() =>
                          handleDownloadInstallmentAdjustmentDocument(
                            InstallmentAdjustLotPaymentId
                          )
                        }
                      >
                        Download Document
                      </CButton>
                    )
                  }
                  disabledBtn={false}
                  btnCColstyle={{ textAlign: "right" }}
                  btnSubmitShow={true}
                  btnCloseText={"Close"}
                  btnCloseShow={true}
                />
              </>
            </div>
            <div>
              <CustomeModalPopup
                onOpen={PaymentBreakoutOpen}
                onClose={handlePaymentBreakoutClose}
                //onSubmitButton={""}
                onCloseButton={handlePaymentBreakoutClose}
                popupWith={520}
                body={
                  <>
                    <CRow>
                      <CCol>
                        <CLabel>
                          <h4>Installment Payment Breakout</h4>
                        </CLabel>
                      </CCol>
                    </CRow>
                    {/* {IsLastInstallment === true ? "true" : "n/A"} */}
                    <hr />
                   

                    <CRow className="mb-2">
                      <CCol xl={6}>Payment Amount</CCol>
                      <CCol xl={4}>{(paymentAmount * 100) / 100}</CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>CGST</CCol>
                      <CCol xl={4}>{CGSTAmount}</CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>SGST</CCol>
                      <CCol xl={4}>{SGSTAmount}</CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>IGST</CCol>
                      <CCol xl={4}>{IGSTAmount}</CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>IncomeTax</CCol>
                      <CCol xl={4}>
                        {IncomeTaxAmount} ({IncomeTaxConsessionPercentage}%)
                      </CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol className="mb-2" xl={6}>
                        Access Benefit Sharing
                      </CCol>
                      <CCol xl={4}>{accessBenefitSharingAmount}</CCol>
                    </CRow>

                    {TotalLateFees > 0 ? (
                      <CRow className="mb-2">
                        <CCol className="mb-2" xl={6}>
                          Late Fees
                        </CCol>
                        <CCol xl={4}>{TotalLateFees}</CCol>
                      </CRow>
                    ) : (
                      ""
                    )}

                    {/* {AdjustmentAmt > 0 ? ( */}
                    <CRow className="mb-2">
                      <CCol className="mb-2" xl={6}>
                        Final Installment Adjustment
                      </CCol>
                      <CCol xl={4}>{AdjustmentAmt}</CCol>
                    </CRow>
                    {/* ) : (
                    ""
                  )} */}

                    <hr />
                    <CRow className="mb-2">
                      <CCol className="mb-2" xl={6}>
                        <strong>Total</strong>
                      </CCol>
                      <CCol xl={4}>
                        <strong>
                          {((paymentAmount * 100) / 100 +
                            CGSTAmount +
                            SGSTAmount +
                            IGSTAmount +
                            IncomeTaxAmount +
                            accessBenefitSharingAmount +
                            (TotalLateFees > 0 ? TotalLateFees : 0) +
                            AdjustmentAmt).toFixed(2)}
                        </strong>
                      </CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>- 2% Rebate on Actual Payment Amount</CCol>
                      <CCol xl={4} style={{ color: "red" }}>
                        {rebateOnFullPayment}
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-2">
                      <CCol className="mb-2" xl={6}>
                        <strong>Total</strong>
                      </CCol>
                      <CCol xl={4}>
                        <strong>
                          {(
                            (paymentAmount * 100) / 100 +
                            CGSTAmount +
                            SGSTAmount +
                            IGSTAmount +
                            IncomeTaxAmount +
                            accessBenefitSharingAmount +
                            (TotalLateFees > 0 ? TotalLateFees : 0) +
                            AdjustmentAmt -
                            rebateOnFullPayment
                          ).toFixed(2)}
                        </strong>
                      </CCol>
                    </CRow>
                    <CRow className="mb-2">
                      <CCol xl={6}>+ 5 % on Actual Payment Amount</CCol>
                      <CCol xl={4}>{+add5PerOnFinalAmount}</CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-2">
                      <CCol className="mb-2" xl={6}>
                        <strong>Total</strong>
                      </CCol>
                      <CCol xl={4}>
                        <strong>
                          { (IsLastInstallment !== true)?Math.ceil(
                            (paymentAmount * 100) / 100 +
                            CGSTAmount +
                            SGSTAmount +
                            IGSTAmount +
                            IncomeTaxAmount +
                            accessBenefitSharingAmount +
                            (TotalLateFees > 0 ? TotalLateFees : 0) +
                            AdjustmentAmt -
                            rebateOnFullPayment +
                            add5PerOnFinalAmount
                          ):(((
                            (paymentAmount * 100) / 100 +
                            CGSTAmount +
                            SGSTAmount +
                            IGSTAmount +
                            IncomeTaxAmount +
                            accessBenefitSharingAmount +
                            (TotalLateFees > 0 ? TotalLateFees : 0) +
                            AdjustmentAmt -
                            rebateOnFullPayment +
                            add5PerOnFinalAmount
                          ).toFixed(2)))}
                        </strong>
                      </CCol>
                    </CRow>
                    {(rebateOnFullPayment > 0 || IsLastInstallment === true)  ? (
                      <>

                      {
                        <>
                        <CRow className="mb-2">
                          <CCol xl={6}>- EMD Amount</CCol>
                          <CCol xl={4} style={{ color: "red" }}>
                            {EMDAmount}
                          </CCol>
                        </CRow>
                        <CRow className="mb-2">
                          <CCol xl={6}>- Security Deposite Amount</CCol>
                          <CCol xl={4} style={{ color: "red" }}>
                            {ADDAmount}
                          </CCol>
                        </CRow>
                        {AdditionalSDAmount > 0 ? (
                          <CRow className="mb-2">
                            <CCol xl={6}>
                              - Additional Security Deposite Amount
                            </CCol>
                            <CCol xl={4} style={{ color: "red" }}>
                              {AdditionalSDAmount}
                            </CCol>
                          </CRow>
                        ) : (
                          ""
                        )}
                        </>
                        }

                        <hr />
                        <CRow className="mb-2">
                          <CCol className="mb-2" xl={6}>
                            <strong>Total</strong>
                          </CCol>
                          <CCol xl={4}>
                            <strong>{
                             Math.ceil(
                                    (paymentAmount * 100) / 100 +
                                    CGSTAmount +
                                    SGSTAmount +
                                    IGSTAmount +
                                    IncomeTaxAmount +
                                    accessBenefitSharingAmount +
                                    (TotalLateFees > 0 ? TotalLateFees : 0) +
                                    AdjustmentAmt -
                                    rebateOnFullPayment +
                                    add5PerOnFinalAmount -
                                    EMDAmount -
                                    ADDAmount -
                                    (AdditionalSDAmount > 0
                                      ? AdditionalSDAmount
                                      : 0)
                                  )
                                }
                          
                            </strong>
                          </CCol>
                        </CRow>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
                disabledBtn={false}
                btnCColstyle={{ textAlign: "right" }}
                heightSet={"86.8%"}
                btnSubmitShow={false}
                btnCloseText={"Close"}
              />
            </div>
            <div>
              <CustomeModalPopup
                onOpen={refundopen}
                onClose={handleRefundPopupClose}
                onCloseButton={handleRefundPopupClose}
                popupWith={"90%"}
                body={
                  <CommonList
                    items={refundStatusList}
                    fields={fieldsRefunds}
                    listName="Refund History"
                    loading={false}
                    disabledprev={true}
                    disablednext={true}
                    displayPaggingButton={false}
                    scopedSlots={refundScopedSlotsList}
                  />
                }
                isFromSubmit={false}
                btnCColstyle={{ textAlign: "right" }}
                disabledBtn={false}
                btnSubmitShow={false}
                btnCloseText={"Close"}
                btnCloseShow={true}
              />
            </div>
            <div>
              <Modal
                open={BGRefundPopUpOpen}
                onClose={handleBGRefundClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={stylTaxConsession} elevation={4}>
                  <CForm
                    className="needs-validation"
                    onSubmit={HandlerBGRefundSubmit}
                  >
                    <CRow>
                      <CCol>
                        <CLabel>LotNo: {BGRefundLotNo}</CLabel>
                      </CCol>
                      <CCol>
                        <CLabel>Amount: {BGRefundAmount}</CLabel>
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>BG Refund Date :</CLabel>
                        <CInput
                          type="date"
                          placeholder=""
                          required
                          //value={additionalSDLastDate === null ? " " : additionalSDLastDate}
                          id="validationCustom28"
                          onChange={(e) => setBGRefundDate(e.target.value)}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Comments :</CLabel>
                        <CTextarea
                          id="reason"
                          required
                          // value={RejectionReason}
                          onChange={(e) => setBGRefundComment(e.target.value)}
                        />
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-3">
                      <CCol style={{ textAlign: "right" }}>
                        <CButton
                          className="mt-3 ml-2 mr-2"
                          color="success"
                          type="submit"
                        >
                          Submit
                        </CButton>
                        <CButton
                          className="mt-3 ml-2 mr-2 btn-dark"
                          onClick={() => handleBGRefundClose()}
                        >
                          Close
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
            <div>
              <Modal
                open={GenerateParidhanAadeshOpen}
                onClose={handleParidhanAadeshClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
              >
                <Paper style={stylTaxConsession} elevation={4}>
                  <CForm
                    className="needs-validation"
                    onSubmit={HandlerGenerateParidhanAadeshSubmit}
                  >
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Paridhan Aadesh /T.P. Date :</CLabel>
                        <CInput
                          type="date"
                          placeholder=""
                          required
                          //value={additionalSDLastDate === null ? " " : additionalSDLastDate}
                          id="validationCustom28"
                          onChange={(e) => setPADate(e.target.value)}
                        />
                      </CCol>
                      <CCol>
                        <CLabel>T.P. No :</CLabel>
                        <CInput
                          required
                          id="txttpno"
                          maxLength={200}
                          onChange={(e) => setTPNO(e.target.value)}
                          invalid={TPNO === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Forest Range :</CLabel>
                        <CInput
                          required
                          id="txtforestrange"
                          maxLength={200}
                          onChange={(e) => setForestRange(e.target.value)}
                          invalid={ForestRange === "" ? true : false}
                        />
                      </CCol>
                      <CCol>
                        <CLabel>Godown Name :</CLabel>
                        <CInput
                          maxLength={300}
                          required
                          //value={additionalSDLastDate === null ? " " : additionalSDLastDate}
                          id="txtgodownname"
                          onChange={(e) => setGodownName(e.target.value)}
                          invalid={GodownName === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>District :</CLabel>
                        <CSelect
                          required
                          aria-label="Default select example"
                          onChange={(e) => {
                            setPADistrictId(e.target.value);
                          }}
                          invalid={PADistrictId === "" ? true : false}
                          id="validationCustom20"
                        >
                          <option value="">Select District Union</option>
                          {DistItems.map((item, key) => (
                            <option key={key} value={item.districtId}>
                              {item.name}
                            </option>
                          ))}
                        </CSelect>
                      </CCol>
                      <CCol>
                        <CLabel>Address :</CLabel>
                        <CTextarea
                          id="txtAddress"
                          required
                          onChange={(e) => setAddress(e.target.value)}
                          invalid={Address === "" ? true : false}
                        />
                      </CCol>
                    </CRow>

                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Due Days :</CLabel>
                        <CInput
                          required
                          onChange={(e) => {
                            setDueDays(e.target.value);
                          }}
                          id="txtDueDays"
                          type="number"
                          invalid={DueDays === "" ? true : false}
                        />
                      </CCol>
                      <CCol>
                        <CLabel>Receiver 1 Name :</CLabel>
                        <CInput
                          required
                          id="txtReceiverName1"
                          maxLength={100}
                          onChange={(e) => setReceiverName1(e.target.value)}
                          invalid={ReceiverName1 === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Receiver 1 Father Name :</CLabel>
                        <CInput
                          required
                          id="txtReceiverFatherName1"
                          maxLength={100}
                          onChange={(e) => setReceiverFName1(e.target.value)}
                          invalid={ReceiverFName1 === "" ? true : false}
                        />
                      </CCol>
                      <CCol>
                        <CLabel>Receiver 1 Address :</CLabel>

                        <CTextarea
                          id="txtAddress"
                          required
                          maxLength={1000}
                          onChange={(e) => setReceiverAddress1(e.target.value)}
                          invalid={ReceiverAddress1 === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Receiver 2 Name :</CLabel>
                        <CInput
                          id="txtReceiverName2"
                          maxLength={100}
                          onChange={(e) => setReceiverName2(e.target.value)}
                          invalid={ReceiverName2 === "" ? true : false}
                        />
                      </CCol>
                      <CCol>
                        <CLabel>Receiver 2 Father Name :</CLabel>
                        <CInput
                          id="txtReceiverFatherName2"
                          maxLength={100}
                          onChange={(e) => setReceiverFName2(e.target.value)}
                          invalid={ReceiverFName2 === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <CRow className="mb-3">
                      <CCol>
                        <CLabel>Receiver 2 Address :</CLabel>
                        <CTextarea
                          id="txtAddress2"
                          maxLength={1000}
                          onChange={(e) => setReceiverAddress2(e.target.value)}
                          invalid={ReceiverAddress2 === "" ? true : false}
                        />
                      </CCol>
                    </CRow>
                    <hr />
                    <CRow className="mb-3">
                      <CCol style={{ textAlign: "right" }}>
                        <CButton
                          className="mt-3 ml-2 mr-2"
                          color="success"
                          type="submit"
                        >
                          Submit
                        </CButton>
                        <CButton
                          className="mt-3 ml-2 mr-2 btn-dark"
                          onClick={() => handleParidhanAadeshClose()}
                        >
                          Close
                        </CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </Paper>
              </Modal>
            </div>
            <div>
              <ConfirmationPopup
                showModal={CPopUpDisplayConfirmationModal}
                hideModal={handleConfirmationPopUpModalClose}
                confirmModal={SubmitConfirmationPopUpResponse}
                id={CPopUpId}
                index={CPopUpIndex}
                ModalBody={CPopUpBodyText}
                //ModalTitle={CPopUpTitle}
                confirmButtonCss="btn btn-danger"
                ButtonLoader={false}
              />
            </div>
          </CCardBody>
        )
      )}
    </>
  );
};
export default LotlistView;
